const app_url = "https://admin.travsim.com/api";
// const app_url = "https://staging.admin.travsim.com/api";
// const app_url = "http://localhost:3000";

// ==================================================================
// You need to import the dependencies for flatpicker in theme.liquid
// ==================================================================

document.addEventListener("DOMContentLoaded", function() {
    const isMobile = window.innerWidth < 768;
    
    // Add dynamic style to ensure flatpickr calendar displays correctly in inline mode
    const style = document.createElement('style');
    style.textContent = `
        @media screen and (max-width: 767px) {
            .flatpickr-calendar.inline {
                width: 100% !important;
            }
            .flatpickr-days {
                width: 100% !important;
            }
            .flatpickr-rContainer {
                width: 100% !important;
            }
            .dayContainer {
                width: 100% !important;
                min-width: 100% !important;
                max-width: 100% !important;
            }
            .flatpickr-current-month {
                left: 0 !important;
                width: 100% !important;
                padding: 0 40px !important;
                text-align: center !important;
                display: flex !important;
                justify-content: center !important;
            }
            .flatpickr-current-month .cur-month,
            .flatpickr-current-month .numInputWrapper {
                display: inline-block !important;
            }
            /* Fix weekday header text */
            span.flatpickr-weekday {
                font-size: 14px !important;
                font-weight: bold !important;
                color: #333 !important;
            }
        }
    `;
    document.head.appendChild(style);
    
    // Initialize the flatpickr
    const flatpickrInstance = flatpickr("#dateRange", {
        mode: "range",  
        dateFormat: "Y-m-d",  
        minDate: "today",  
        defaultDate: [], 
        showMonths: isMobile ? 1 : 2, // Show 1 month on mobile to avoid layout issues
        static: isMobile, 
        disableMobile: true, 
        position: isMobile ? "auto" : "auto", 
        // inline: isMobile, 
        closeOnSelect: false, // Don't close automatically on select
        locale: {
            firstDayOfWeek: 1, // Monday as first day of the week
            weekdays: {
                shorthand: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            },
            months: {
                shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            }
        },
        onReady: function(selectedDates, dateStr, instance) {
          // Close button is available at every breakpoint
            addCloseButton(instance);  
          // Fix the calendar layout after it's fully rendered
            if (window.innerWidth < 768) {
                setTimeout(() => {
                    fixCalendarLayout(instance);
                    // Don't hide navigation arrows for single month view
                    // hideNavigationArrows(instance);
                    addDoneButtonToCalendar(instance);
                }, 100);
            }
        },
        onOpen: function(selectedDates, dateStr, instance) {
          // Clear any leftover inline display:none left by the close/Done buttons,
            // otherwise the calendar can never show again after being closed
            instance.calendarContainer.style.removeProperty('display');
            // Make sure we have a close button
            if (!instance.calendarContainer.querySelector('.flatpickr-close-button')) {
                addCloseButton(instance);
            }
            // Add a class to the calendar to help with styling
            if (window.innerWidth < 768) {
                instance.calendarContainer.classList.add("is-mobile");
                setTimeout(() => {
                    fixCalendarLayout(instance);
                    // Make sure we have a close button
                    if (!instance.calendarContainer.querySelector('.flatpickr-close-button')) {
                        addCloseButton(instance);
                    }
                    // Make sure we have a done button
                    if (!instance.calendarContainer.querySelector('.flatpickr-mobile-done-btn')) {
                        addDoneButtonToCalendar(instance);
                    }
                }, 100);
            }
        },
        onChange: function(selectedDates, dateStr, instance) {
          // Clicking the same date twice gives flatpickr a zero-length range
            // (start === end) instead of collapsing back to one date — expand it
            // to a 2-day span instead of closing on a same-day "range".
            if (selectedDates.length === 2 && selectedDates[0].getTime() === selectedDates[1].getTime()) {
                const start = selectedDates[0];
                const next = new Date(start);
                next.setDate(next.getDate() + 1);
                instance.setDate([start, next], true); // re-triggers onChange with the real range
                return;
            }  
          
          // Check if the user has selected a range
            if (selectedDates.length >= 2) {
                console.log('Date range selected:', dateStr);
                // Auto-close once a full range (start + end) has been picked
                instance.close();
            }
            
            // Hide error message if it was previously shown
            const errorElement = document.getElementById('dateRange-error');
            if (errorElement) {
                errorElement.style.display = 'none';
            }
        },
        onClose: function(selectedDates, dateStr, instance) {
            // If the user only picked a start date, default the end date to the next day
            if (selectedDates.length === 1) {
                const start = selectedDates[0];
                const next = new Date(start);
                next.setDate(next.getDate() + 1);
                instance.setDate([start, next], true);
            }
        }
    });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            const wasMobile = window.innerWidth < 768;
            if (wasMobile !== isMobile) {
                // Reinitialize flatpickr if the device type changes
                location.reload();
            } else if (wasMobile) {
                // Just fix the layout if still mobile
                const instance = document.querySelector('#dateRange')?._flatpickr;
                if (instance) {
                    fixCalendarLayout(instance);
                    
                    // Make sure buttons are present
                    if (!instance.calendarContainer.querySelector('.flatpickr-close-button')) {
                        addCloseButton(instance);
                    }
                    if (!instance.calendarContainer.querySelector('.flatpickr-mobile-done-btn')) {
                        addDoneButtonToCalendar(instance);
                    }
                }
            }
        }, 250);
    });

    // Initialize the sim code input validation
    initSimCodeValidation();
});

function setDateRange(startDate, endDate) {
    const datePicker = document.querySelector("#dateRange")._flatpickr;
    
    if (datePicker) {
         console.log("Setting date range:", startDate, endDate);
        datePicker.clear(); // ✅ Clears any pre-set default value
        datePicker.setDate([startDate, endDate], true);
    } else {
        console.error("Flatpickr is not initialized yet.");
    }
}

function setStartDate(startDate) {
    const datePicker = document.querySelector("#dateRange")._flatpickr;
    
    if (datePicker) {
        datePicker.setDate([startDate], true); // Set only the start date, leaving end date blank
    } else {
        console.error("Flatpickr is not initialized yet.");
    }
}

// **Helper Function to Format Dates Without UTC Conversion**
function formatDateLocal(date) {
    const yyyy = date.getFullYear();
    let mm = date.getMonth() + 1; // Months are zero-based
    let dd = date.getDate();

    mm = mm < 10 ? "0" + mm : mm;
    dd = dd < 10 ? "0" + dd : dd;

    return `${yyyy}-${mm}-${dd}`;
}

// Helper to format dates as M/D/YYYY
function formatDate(dateStr) {
  if (!dateStr) return '—';
  const dateObj = new Date(dateStr);
  if (isNaN(dateObj)) return dateStr; // fallback if invalid
  return (dateObj.getMonth() + 1) + '/' + dateObj.getDate() + '/' + dateObj.getFullYear();
}

// // Customize the form based on the selected SIM type
// function customizeFormForSimType(simType) {
//     // You can customize the form based on the SIM type
//     // For example, show/hide specific fields, change labels, etc.
    
//     // This is a placeholder function that can be expanded later
//     console.log(`Customizing form for SIM type: ${simType}`);
    
//     // Example: Change the form title based on the SIM type
//     const formTitle = document.querySelector('#activation-form h1');
//     if (formTitle) {
//         switch(simType) {
//             case 'gps':
//                 formTitle.textContent = 'GPS Tracker SIM Activation';
//                 break;
//             case 'lycamobile':
//                 formTitle.textContent = 'Lycamobile & T-Mobile USA SIM Activation';
//                 break;
//             case 'travel':
//                 formTitle.textContent = 'Travel SIM Activation';
//                 break;
//             case 'lebara':
//                 formTitle.textContent = 'Lebara SIM Activation';
//                 break;
//             default:
//                 formTitle.textContent = 'SIM Activation';
//         }
//     }
// }

// function setDateRange(startDate, endDate) {
//     const datePicker = document.querySelector("#dateRange")._flatpickr;
    
//     if (datePicker) {
//          console.log("Setting date range:", startDate, endDate);
//         datePicker.clear(); // ✅ Clears any pre-set default value
//         datePicker.setDate([startDate, endDate], true);
//     } else {
//         console.error("Flatpickr is not initialized yet.");
//     }
// }

// function setStartDate(startDate) {
//     const datePicker = document.querySelector("#dateRange")._flatpickr;
    
//     if (datePicker) {
//         datePicker.setDate([startDate], true); // Set only the start date, leaving end date blank
//     } else {
//         console.error("Flatpickr is not initialized yet.");
//     }
// }

// // **Helper Function to Format Dates Without UTC Conversion**
// function formatDateLocal(date) {
//     const yyyy = date.getFullYear();
//     let mm = date.getMonth() + 1; // Months are zero-based
//     let dd = date.getDate();

//     mm = mm < 10 ? "0" + mm : mm;
//     dd = dd < 10 ? "0" + dd : dd;

//     return `${yyyy}-${mm}-${dd}`;
// }

// // Helper to format dates as M/D/YYYY
// function formatDate(dateStr) {
//   if (!dateStr) return '—';
//   const dateObj = new Date(dateStr);
//   if (isNaN(dateObj)) return dateStr; // fallback if invalid
//   return (dateObj.getMonth() + 1) + '/' + dateObj.getDate() + '/' + dateObj.getFullYear();
// }

// document.addEventListener("DOMContentLoaded", function() {
// // Set min attribute for activationDate input to today
//   const activationDateInput = document.getElementById("activationDate");
//   const today = new Date();
//   const yyyy = today.getFullYear();
//   let mm = today.getMonth() + 1;
//   let dd = today.getDate();
//   if (mm < 10) mm = "0" + mm;
//   if (dd < 10) dd = "0" + dd;
//   const todayFormatted = `${yyyy}-${mm}-${dd}`;
//   activationDateInput.setAttribute("min", todayFormatted);

//   // Optionally, if activationEnd is provided, update its min when activationDate changes
//   activationDateInput.addEventListener("change", function() {
//     if (this.value) {
//       const activationDateObj = new Date(this.value);
//       // Set activationEnd to be at least one day after the selected activation date
//       activationDateObj.setDate(activationDateObj.getDate() + 1);
//       const yyyy = activationDateObj.getFullYear();
//       let mm = activationDateObj.getMonth() + 1;
//       let dd = activationDateObj.getDate();
//       if (mm < 10) mm = "0" + mm;
//       if (dd < 10) dd = "0" + dd;
//       const minEndDate = `${yyyy}-${mm}-${dd}`;
//       document.getElementById("activationEnd").setAttribute("min", minEndDate);
//     }
//   });
// });


// NEW: Only use requestActivationData if valid
function populateActivationForm() {
  const data = window.requestActivationData || {};

  // Check if requestActivationData is valid (here we assume a valid object has a simCode)
  if (!data.simCode) {
    console.warn("No valid requestActivationData found.");
    return;
  }

  // Update unified container elements (activation details container)
  if (data.simCode) {
    document.getElementById("activation-sim-code").textContent = data.simCode;
    // Also update the SIM code display in the container-activate (new activation form)
    document.getElementById("display-sim-code").textContent = data.simCode;
    document.getElementById("simCode").value = data.simCode;
  }

  // Update personal information
  if (data.firstName || data.lastName) {
    const fullName = (data.firstName || "") + " " + (data.lastName || "");
    document.getElementById("activation-name").textContent = fullName.trim();
    document.getElementById("firstName").value = data.firstName || "";
    document.getElementById("lastName").value = data.lastName || "";
  }
  if (data.email) {
    document.getElementById("activation-email").textContent = data.email;
    document.getElementById("email").value = data.email;
  }

  console.log("data.activationDate");
    console.log(data.activationDate);
    console.log("data.activationEnd");
    console.log(data.activationEnd);

  // Update activation dates
  if (data.activationDate != null & data.activationEnd != null) {
    document.getElementById("activation-dates").textContent = formatDate(data.activationDate) + " until " + formatDate(data.activationEnd);
    console.log("Setting date");
    // document.getElementById("activationDate").value = data.activationDate;
    setDateRange(data.activationDate, data.activationEnd);
  }
  else if (data.activationEnd != null) {
    document.getElementById("activation-dates").textContent = formatDate(data.activationDate)
    setStartDate(data.activationDate);
    // document.getElementById("activationEnd").value = data.activationEnd;
  }
  

}

// Function to clear all messages when navigating away from activation pages
function clearAllMessages() {
    const errorContainers = document.querySelectorAll('[id$="-activation-errors"]');
    errorContainers.forEach(container => {
        container.style.display = 'none';
    });
}

// Local storage helpers for SIM code persistence
const SIM_CODE_STORAGE_KEY = 'sim-activation:sim-code';
function setStoredSimCode(value) {
    try { localStorage.setItem(SIM_CODE_STORAGE_KEY, value); } catch (e) {}
}
function getStoredSimCode() {
    try { return localStorage.getItem(SIM_CODE_STORAGE_KEY) || ''; } catch (e) { return ''; }
}
function clearStoredSimCode() {
    try { localStorage.removeItem(SIM_CODE_STORAGE_KEY); } catch (e) {}
}

// Resolve the brandId for the current site; prefer window/meta, fallback to 2 (BeachSim)
function getPageBrandId() {
    var meta = document.querySelector('meta[name="brand-id"]');
    var metaVal = meta && meta.content ? meta.content : null;
    var winVal = (typeof window !== 'undefined' && window.brandId != null) ? window.brandId : null;
    var resolved = Number(winVal || metaVal || 2);
    return Number.isNaN(resolved) ? 2 : resolved;
}

function showBrandMismatchError(targetId) {
    var el = document.getElementById(targetId);
    if (!el) return;
    el.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#DC2626"/>' +
      '</svg> <span style="margin-left: 8px;">We could not find this SIM in our system. Double-check the number or reach out to your seller for support.</span>';
    el.className = 'activation-status-text blocked';
    el.style.display = 'flex';
    // Ensure the main form is visible so the message can be seen
    var activationForm = document.getElementById('activation-form');
    if (activationForm) activationForm.style.display = 'block';
    // Reset Next button state
    var nextButton = document.getElementById('sim-code-form')?.querySelector('button[type="submit"]');
    if (nextButton) {
        nextButton.disabled = false;
        nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
    }
}

// Reset the activation form and show the landing page
function resetActivationForm() {
    // Clear stored SIM code and remove legacy URL parameters if present
    clearStoredSimCode();
    // Remove sim-code parameter from URL
    const url = new URL(window.location.href);
    url.searchParams.delete('sim-code');
    url.searchParams.delete('qr');
    window.history.replaceState({}, '', url);
    
    // Hide all forms
    const forms = [
        'new-activation-form',
        'activation-details-container',
        'success-message',
        'gps-tracker-form',
        'lycamobile-form',
        'travel-sim-form',
        'activation-success',
        'activation-success-messages',
        'change-details-form',
        'esim-external-activation',
        'verified-auth-message'
    ];
    
    forms.forEach(formId => {
        const form = document.getElementById(formId);
        if (form) {
            form.style.display = 'none';
            
            // Reset form fields if it's an actual form
            if (form.tagName === 'FORM') {
                form.reset();
                
                // Handle special case for Travel SIM form
                if (formId === 'travel-sim-form') {
                    // Hide Swiss passport section
                    const swissPassportSection = document.getElementById('swiss-passport-section');
                    if (swissPassportSection) {
                        swissPassportSection.style.display = 'none';
                    }
                    
                    // Reset file upload fields
                    const fileInputs = ['travelIdFront', 'travelIdBack'];
                    fileInputs.forEach(inputId => {
                        const fileNameSpan = document.getElementById(`${inputId}Name`);
                        if (fileNameSpan) {
                            fileNameSpan.textContent = window.simActivationMessages.no_file_chosen_text;
                        }
                    });
                }
            }
        }
    });
    
    // Make success activation containers visible again for future use
    const successContainers = [
        'success-activation-sim-code-container',
        'success-activation-user-info-container'
    ];
    
    successContainers.forEach(containerId => {
        const container = document.getElementById(containerId);
        if (container) {
            container.style.display = 'block';
        }
    });
    
    // Reset "Change details" buttons visibility
    const changeDetailsLinks = document.querySelectorAll('a[onclick="showChangeDetailsForm()"]');
    changeDetailsLinks.forEach(link => {
        link.style.display = 'inline-block';
        link.style.visibility = 'visible';
    });
    
    // Reset the main activation form
    const mainForm = document.getElementById('sim-code-form');
    if (mainForm) {
        mainForm.reset();
    }
    
    // Clear the SIM code input field and its feedback state
    const simCodeInput = document.getElementById('sim-code');
    if (simCodeInput) {
        simCodeInput.value = '';
        simCodeInput.classList.remove('is-invalid', 'is-valid', 'error-input');
    }

    // Reset the character counter
    const charCounter = document.getElementById('sim-code-counter');
    if (charCounter) {
        charCounter.textContent = '0 / 22';
    }

    // Reset the requirements checklist to its neutral state
    const requirementsList = document.getElementById('sim-code-requirements');
    if (requirementsList) {
        requirementsList.querySelectorAll('li[data-rule]').forEach((li) => {
            li.classList.remove('is-pass', 'is-fail');
            const icon = li.querySelector('.rule-icon');
            if (icon) icon.innerHTML = '';
        });
    }

    const statusIcon = document.getElementById('sim-code-status');
    if (statusIcon) {
        statusIcon.className = 'sim-code-field__status';
        statusIcon.innerHTML = '';
    }
    
    // Clear error message and icon
    const errorMessage = document.getElementById('error-message');
    if (errorMessage) {
        errorMessage.innerHTML = '';
        errorMessage.style.display = 'none';
        errorMessage.className = ''; // Remove any error-related classes
    }
    
    // Make sure Swiss passport section is hidden
    const swissPassportSection = document.getElementById('swiss-passport-section');
    if (swissPassportSection) {
        swissPassportSection.style.display = 'none';
    }
    
    // Show the main activation form
    const activationForm = document.getElementById('activation-form');
    if (activationForm) {
        activationForm.style.display = 'block';
    }
    
    // Enable the Next button
    const nextButton = document.getElementById('sim-code-form').querySelector('button[type="submit"]');
    if (nextButton) {
        nextButton.disabled = false;
        nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
    }
    
    // Clear all error messages
    clearAllMessages();
}

// Shows the form for changing details (reusing the new activation form)
// function showChangeDetailsForm() {
//   clearSuccessMessages();
//   // Hide the unified activation details container
//   document.getElementById("activation-details-container").style.display = "none";
//   // Show the new activation form (for editing details)
//   document.getElementById("new-activation-form").style.display = "block";
//   populateActivationForm();
// }


// Shows the form for changing details 
function showChangeDetailsForm() {
  clearSuccessMessages();
  // Hide the unified activation details container
  document.getElementById("activation-details-container").style.display = "none";
  // Show the change details form
  document.getElementById("change-details-form").style.display = "block";

  // Populate the form with the current SIM card information
  const simCode = getStoredSimCode();
  document.getElementById("change-details-sim-code").textContent = simCode;
  document.getElementById("change-details-simCode").value = simCode;

  // If we have current activation details, populate the form with them
  if (window.currentActivationDetails) {
    document.getElementById("change-details-firstName").value = window.currentActivationDetails.firstName || "";
    document.getElementById("change-details-lastName").value = window.currentActivationDetails.lastName || "";
    // document.getElementById("change-details-email").value = window.currentActivationDetails.email || "";
    document.getElementById("change-details-email").value = "";

    // Set the date range if available
    if (window.currentActivationDetails.activationDate) {
      const activationDateStr = window.currentActivationDetails.activationDate;
      const activationEndStr = window.currentActivationDetails.activationEnd || "";

      // Initialize flatpickr for change-details-dateRange if it exists
      const dateRangeElement = document.getElementById("change-details-dateRange");
      if (typeof flatpickr !== "undefined" && dateRangeElement) {
        // Destroy existing flatpickr instance if it exists
        if (dateRangeElement._flatpickr) {
          dateRangeElement._flatpickr.destroy();
        }

        // Detect if mobile for proper configuration
        const isMobile = window.innerWidth < 768;

        // Initialize flatpickr with the same comprehensive configuration as main form
        const fp = flatpickr(dateRangeElement, {
          mode: "range",  
          dateFormat: "Y-m-d",  
          minDate: "today",  
          defaultDate: activationEndStr ? [activationDateStr, activationEndStr] : [activationDateStr],
          showMonths: isMobile ? 1 : 2, // Show 1 month on mobile to avoid layout issues
          static: isMobile, 
          disableMobile: true, 
          position: isMobile ? "auto" : "auto", 
          closeOnSelect: false, // Don't close automatically on select
          locale: {
            firstDayOfWeek: 1, // Monday as first day of the week
            rangeSeparator: " to ",
            weekdays: {
                shorthand: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            },
            months: {
                shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            }
          },
          onReady: function(selectedDates, dateStr, instance) {
            // Close button is available at every breakpoint
            addCloseButton(instance);
            // Fix the calendar layout after it's fully rendered
            if (window.innerWidth < 768) {
                setTimeout(() => {
                    fixCalendarLayout(instance);
                    addDoneButtonToCalendar(instance);
                }, 100);
            }
          },
          onOpen: function(selectedDates, dateStr, instance) {
            // Clear any leftover inline display:none left by the close/Done buttons,
            // otherwise the calendar can never show again after being closed
            instance.calendarContainer.style.removeProperty('display');
            // Make sure we have a close button
            if (!instance.calendarContainer.querySelector('.flatpickr-close-button')) {
                addCloseButton(instance);
            }
            // Add a class to the calendar to help with styling
            if (window.innerWidth < 768) {
                instance.calendarContainer.classList.add("is-mobile");
                setTimeout(() => {
                    fixCalendarLayout(instance);
                    // Make sure we have a close button
                    if (!instance.calendarContainer.querySelector('.flatpickr-close-button')) {
                        addCloseButton(instance);
                    }
                    // Make sure we have a done button
                    if (!instance.calendarContainer.querySelector('.flatpickr-mobile-done-btn')) {
                        addDoneButtonToCalendar(instance);
                    }
                }, 100);
            }
          },
          onChange: function(selectedDates, dateStr, instance) {
            // Clicking the same date twice gives flatpickr a zero-length range
            // (start === end) instead of collapsing back to one date — expand it
            // to a 2-day span instead of closing on a same-day "range".
            if (selectedDates.length === 2 && selectedDates[0].getTime() === selectedDates[1].getTime()) {
                const start = selectedDates[0];
                const next = new Date(start);
                next.setDate(next.getDate() + 1);
                instance.setDate([start, next], true); // re-triggers onChange with the real range
                return;
            }
            
            // Check if the user has selected a range
            if (selectedDates.length >= 2) {
                console.log('Change details date range selected:', dateStr);
                // Auto-close once a full range (start + end) has been picked
                instance.close();
            }
            
            // Hide error message if it was previously shown
            const errorElement = document.getElementById('change-details-dateRange-error');
            if (errorElement) {
                errorElement.style.display = 'none';
            }
          },
          onClose: function(selectedDates, dateStr, instance) {
            // If the user only picked a start date, default the end date to the next day
            if (selectedDates.length === 1) {
                const start = selectedDates[0];
                const next = new Date(start);
                next.setDate(next.getDate() + 1);
                instance.setDate([start, next], true);
            }
          }
        });
      }
    }

    // Handle IMEI/EID field visibility based on device requirements
    if (window.currentDeviceRequirements) {
      const imeiValid = window.currentDeviceRequirements.some(req => req.name === "IMEI_VALID");
      const eidValid = window.currentDeviceRequirements.some(req => req.name === "EID_VALID");
      
      // Control the entire Device Information section visibility
      const deviceInfoSection = document.querySelector("#change-details-form .new-imei-eid");
      if (deviceInfoSection) {
        if (imeiValid || eidValid) {
          deviceInfoSection.style.display = "block";
        } else {
          deviceInfoSection.style.display = "none";
        }
      }
      
      // Control IMEI field visibility
      const imeiContainer = document.getElementById("change-details-imei-container");
      const imeiInput = document.getElementById("change-details-imei");
      if (imeiContainer && imeiInput) {
        if (imeiValid) {
          imeiContainer.style.display = "flex";
          imeiInput.setAttribute("required", "");
          // Populate with existing value if available
          if (window.currentActivationDetails.imei) {
            imeiInput.value = window.currentActivationDetails.imei;
          }
          updateNumericCounter(imeiInput, document.getElementById("change-details-imei-counter"), 15);
        } else {
          imeiContainer.style.display = "none";
          imeiInput.removeAttribute("required");
          imeiInput.value = "";
          updateNumericCounter(imeiInput, document.getElementById("change-details-imei-counter"), 15);
        }
      }
      
      // Control EID field visibility
      const eidContainer = document.getElementById("change-details-eid-container");
      const eidInput = document.getElementById("change-details-eid");
      if (eidContainer && eidInput) {
        if (eidValid) {
          eidContainer.style.display = "block";
          eidInput.setAttribute("required", "");
          // Populate with existing value if available
          if (window.currentActivationDetails.eid) {
            eidInput.value = window.currentActivationDetails.eid;
          }
          updateNumericCounter(eidInput, document.getElementById("change-details-eid-counter"), 32);
        } else {
          eidContainer.style.display = "none";
          eidInput.removeAttribute("required");
          eidInput.value = "";
          updateNumericCounter(eidInput, document.getElementById("change-details-eid-counter"), 32);
        }
      }
    } else {
      // Fallback: show section if we have values for any fields
      const deviceInfoSection = document.querySelector("#change-details-form .new-imei-eid");
      const hasImei = window.currentActivationDetails.imei;
      const hasEid = window.currentActivationDetails.eid;
      
      if (deviceInfoSection) {
        if (hasImei || hasEid) {
          deviceInfoSection.style.display = "block";
        } else {
          deviceInfoSection.style.display = "none";
        }
      }
      
      // Show fields if we have values for them
      if (hasImei) {
        document.getElementById("change-details-imei").value = window.currentActivationDetails.imei;
        document.getElementById("change-details-imei-container").style.display = "block";
      } else {
        document.getElementById("change-details-imei-container").style.display = "none";
      }

      if (hasEid) {
        document.getElementById("change-details-eid").value = window.currentActivationDetails.eid;
        document.getElementById("change-details-eid-container").style.display = "block";
      } else {
        document.getElementById("change-details-eid-container").style.display = "none";
      }
    }
  }
  
  // Set up error clearing when user starts typing
  setupChangeDetailsErrorClearing();
}

// Function to handle validation errors by displaying them similar to the warning messages
function displayValidationErrors(errors) {
  // Get the error message element
  const errorElem = document.getElementById("activation-error-message");
  if (errors && errors.error) {
    errorElem.textContent = errors.error?.message || window.simActivationMessages.unknownError;
    document.getElementById("activation-errors").style.display = "block";
  }
}

// Helper function to get user-friendly field names
function getFieldLabel(fieldName) {
  const fieldLabels = {
    firstName: "First name",
    lastName: "Last name",
    email: "Email address",
    activationDate: "Activation date",
    imei: "IMEI",
    eid: "EID"
  };
  
  return fieldLabels[fieldName] || fieldName;
}

// Helper function to get user-friendly error messages
function getHumanReadableError(fieldName, code, defaultMessage) {
  // Map error codes to friendly messages
  const errorMessages = {
    minLength: window.simActivationMessages.fieldRequiredError || "This field is required",
    format: {
      email: window.simActivationMessages.emailFormatError || "Must be a valid email address",
      activationDate: window.simActivationMessages.dateFormatError || "Must be a valid date"
    },
    pattern: {
      imei: window.simActivationMessages.imeiPatternError || "Must be 15 digits",
      eid: window.simActivationMessages.eidPatternError || "Must be 32 digits"
    }
  };
  
  // Special handling for activationEnd - if it's empty, we don't want to show an error
  if (fieldName === "activationEnd") {
    return null; // Don't show error for empty activationEnd
  }
  
  // Return appropriate message or fall back to default
  if (code === "format" && errorMessages.format[fieldName]) {
    return errorMessages.format[fieldName];
  } else if (code === "pattern" && errorMessages.pattern[fieldName]) {
    return errorMessages.pattern[fieldName];
  } else if (errorMessages[code]) {
    return errorMessages[code];
  }
  
  return defaultMessage;
}

// Submit function for the Change Details form
async function submitChangeDetails(event) {
  event.preventDefault();

  // Hide any previous error messages
  document.getElementById("change-details-errors").style.display = "none";

  // Get the form data
  const simCode = document.getElementById("change-details-simCode").value;
  const firstName = document.getElementById("change-details-firstName").value;
  const lastName = document.getElementById("change-details-lastName").value;
  const email = document.getElementById("change-details-email").value;
  const language = document.getElementById("change-details-language").value;
  const brandId = getPageBrandId();

  // Get the date range values (these will be handled by flatpickr)
  const dateRangeInput = document.getElementById("change-details-dateRange");
  let activationDate = "";
  let activationEnd = "";

  if (dateRangeInput.value) {
    const dateRange = dateRangeInput.value.split(" to ");
    activationDate = dateRange[0];
    if (dateRange.length > 1) {
      activationEnd = dateRange[1];
    }
  }

  // Get the IMEI and EID values
  const imei = document.getElementById("change-details-imei").value;
  const eid = document.getElementById("change-details-eid").value;

  // Validate the form data
  if (!firstName) {
    document.getElementById("change-details-firstName-error").textContent = window.simActivationMessages.requiredFirstName || "First name is required";
    document.getElementById("change-details-firstName-error").style.display = "block";
    return;
  }

  if (!lastName) {
    document.getElementById("change-details-lastName-error").textContent = window.simActivationMessages.requiredLastName || "Last name is required";
    document.getElementById("change-details-lastName-error").style.display = "block";
    return;
  }

  if (!email) {
    document.getElementById("change-details-email-error").textContent = window.simActivationMessages.requiredEmail || "Email is required";
    document.getElementById("change-details-email-error").style.display = "block";
    return;
  }

  // Validate email format
  if (!isValidEmail(email)) {
    document.getElementById("change-details-email-error").textContent = window.simActivationMessages.invalidEmail || "Please enter a valid email address";
    document.getElementById("change-details-email-error").style.display = "block";
    return;
  }

  // Validate the date range
  if (!activationDate) {
    document.getElementById("change-details-dateRange-error").textContent = window.simActivationMessages.requiredActivationDate || "Activation date is required";
    document.getElementById("change-details-dateRange-error").style.display = "block";
    return;
  }

  // Validate IMEI if the field is visible and required
  const imeiContainer = document.getElementById("change-details-imei-container");
  const imeiInput = document.getElementById("change-details-imei");
  if (imeiContainer && imeiContainer.style.display !== "none" && imeiInput && imeiInput.hasAttribute("required")) {
    if (!imei) {
      document.getElementById("change-details-imei-invalid-error").textContent = window.simActivationMessages.requiredImei || "IMEI is required";
      document.getElementById("change-details-imei-invalid-error").style.display = "block";
      return;
    }
    // Validate IMEI format (15 digits)
    if (!/^[0-9]{15}$/.test(imei)) {
      document.getElementById("change-details-imei-invalid-error").textContent = window.simActivationMessages.imeiPatternError || "IMEI must be 15 digits";
      document.getElementById("change-details-imei-invalid-error").style.display = "block";
      return;
    }
  }

  // Validate EID if the field is visible and required
  const eidContainer = document.getElementById("change-details-eid-container");
  const eidInput = document.getElementById("change-details-eid");
  if (eidContainer && eidContainer.style.display !== "none" && eidInput && eidInput.hasAttribute("required")) {
    if (!eid) {
      document.getElementById("change-details-eid-invalid-error").textContent = window.simActivationMessages.requiredEid || "EID is required";
      document.getElementById("change-details-eid-invalid-error").style.display = "block";
      return;
    }
    // Validate EID format (32 digits)
    if (!/^[0-9]{32}$/.test(eid)) {
      document.getElementById("change-details-eid-invalid-error").textContent = window.simActivationMessages.eidPatternError || "EID must be 32 digits";
      document.getElementById("change-details-eid-invalid-error").style.display = "block";
      return;
    }
  }

  // Clear all error messages if validation passes
  const errorElements = [
    "change-details-firstName-error",
    "change-details-lastName-error", 
    "change-details-email-error",
    "change-details-dateRange-error",
    "change-details-imei-invalid-error",
    "change-details-eid-invalid-error"
  ];
  errorElements.forEach(id => {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = "none";
    }
  });

  // Prepare the request data
  const requestData = {
    simCode,
    firstName,
    lastName,
    email,
    language,
    brandId,
    activationDate,
    activationEnd,
    imei,
    eid
  };

  console.log("requestData");
  console.log(requestData);

  try {
    // Show loading state
    document.getElementById("submit-change-details").textContent = window.simActivationMessages.processing_text || "Processing...";
    document.getElementById("submit-change-details").disabled = true;

    // Call the brand-validated update activation endpoint
    const response = await fetch(`${app_url}/public/beachsim-update-activation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestData)
    });

    // Reset button state
    document.getElementById("submit-change-details").textContent = "Update Details";
    document.getElementById("submit-change-details").disabled = false;

    // Handle the response
    if (response.ok) {
      const result = await response.json();

      // Update the current activation details
      window.currentActivationDetails = {
        ...window.currentActivationDetails,
        firstName,
        lastName,
        email,
        activationDate,
        activationEnd,
        imei,
        eid
      };

      // Show the success message
      document.getElementById("change-details-form").style.display = "none";

      // Display the activation success container
      document.getElementById("activation-success-messages").style.display = "block";

      // Update the displayed information
      document.getElementById("success-activation-sim-code").textContent = simCode;
      document.getElementById("success-activation-name").textContent = `${firstName} ${lastName}`;
      document.getElementById("success-activation-email").textContent = email;

      const formattedActivationDate = formatDate(activationDate);
      const formattedEndDate = activationEnd ? formatDate(activationEnd) : null;

      if (formattedEndDate) {
        document.getElementById("success-activation-dates").textContent = `${formattedActivationDate} - ${formattedEndDate}`;
      } else {
        document.getElementById("success-activation-dates").textContent = `From ${formattedActivationDate}`;
      }

      // Handle IMEI and EID display
      if (imei) {
        document.getElementById("success-activation-imei").textContent = imei;
        document.getElementById("success-activation-imei-container").style.display = "flex";
      } else {
        document.getElementById("success-activation-imei-container").style.display = "none";
      }

      if (eid) {
        document.getElementById("success-activation-eid").textContent = eid;
        document.getElementById("success-activation-eid-container").style.display = "flex";
      } else {
        document.getElementById("success-activation-eid-container").style.display = "none";
      }

      // Show appropriate warnings based on the response
      if (result.showTodayHint) {
        document.getElementById("today-activation-warning").style.display = "block";
      } else {
        document.getElementById("today-activation-warning").style.display = "none";
      }

      if (result.exceedingDurationBy > 0) {
        const exceedingMessage = window.simActivationMessages?.exceeding_duration_warning || "Your selected period exceeds the available duration by {days} days.";
        document.getElementById("exceeding-duration-text").textContent = exceedingMessage.replace("{days}", result.exceedingDurationBy);
        document.getElementById("duration-warning").style.display = "block";

        if (result.rechargeUrl) {
          document.getElementById("recharge-link").href = result.rechargeUrl;
          document.getElementById("recharge-link-container").style.display = "block";
        } else {
          document.getElementById("recharge-link-container").style.display = "none";
        }
      } else {
        document.getElementById("duration-warning").style.display = "none";
      }

    } else {
      // Handle API errors
      const errorData = await response.json();
      let errorMessage = window.simActivationMessages.genericError || "An error occurred. Please try again.";

      if (errorData.error && errorData.error.message) {
        switch (errorData.error.message) {
          case "SIM_CARD_NOT_FOUND":
            errorMessage = window.simActivationMessages.sim_not_found_error || "SIM card not found.";
            break;
          case "ACTIVATION_DISABLED":
            errorMessage = window.simActivationMessages.activation_disabled_error || "Activation is currently disabled.";
            break;
          case "ACTIVATION_DATE_PAST":
            errorMessage = window.simActivationMessages.activation_date_past_error || "The activation date cannot be in the past.";
            break;
          case "ACTIVATION_DATE_MORE_THAN_TEN_MONTHS_AHEAD":
            errorMessage = window.simActivationMessages.activation_date_future_error || "The activation date cannot be more than 10 months in the future.";
            break;
          case "ACTIVATION_IN_PROGRESS":
            errorMessage = window.simActivationMessages.activation_in_progress_error || "Activation is already in progress.";
            break;
          case "ACTIVATION_DONE":
            errorMessage = window.simActivationMessages.activation_done_error || "Activation has already been completed.";
            break;
          case "IMEI_NOT_VALID":
            errorMessage = window.simActivationMessages.imei_not_valid_error || "The IMEI is not valid.";
            break;
          case "EID_NOT_VALID":
            errorMessage = window.simActivationMessages.eid_not_valid_error || "The EID is not valid.";
            break;
          case "EMAIL_MISMATCH":
            errorMessage = "The provided email does not match the email associated with this SIM card.";
            break;
          case "NO_EXISTING_ACTIVATION":
            errorMessage = "There is no existing activation to update. Please activate the SIM card first.";
            break;
          case "BRAND_MISMATCH":
            errorMessage = "This SIM card does not belong to BeachSim.";
            break;
          default:
            errorMessage = errorData.error.message;
        }
      }

      // Display the error message
      document.getElementById("change-details-error-message").textContent = errorMessage;
      document.getElementById("change-details-errors").style.display = "block";
    }
  } catch (error) {
    console.error("Error updating SIM card details:", error);
    document.getElementById("submit-change-details").textContent = "Update Details";
    document.getElementById("submit-change-details").disabled = false;

    // Display network error
    document.getElementById("change-details-error-message").textContent = window.simActivationMessages.networkError || "Network error. Please try again later.";
    document.getElementById("change-details-errors").style.display = "block";
  }
}

// Submit function for the New Activation Details form
async function submitActivationDetails(event) {
  event.preventDefault();

  // Hide any previous error messages
  document.getElementById("activation-errors").style.display = "none";

  // Get the form data
  const simCode = document.getElementById("simCode").value;
  const firstName = document.getElementById("firstName").value;
  const lastName = document.getElementById("lastName").value;
  const email = document.getElementById("email").value;
  const language = document.getElementById("language").value;
  const brandId = getPageBrandId();

  // Get the date range values (these will be handled by flatpickr)
  const dateRangeInput = document.getElementById("dateRange");
  let activationDate = "";
  let activationEnd = "";

  if (dateRangeInput.value) {
    const dateRange = dateRangeInput.value.split(" to ");
    activationDate = dateRange[0];
    if (dateRange.length > 1) {
      activationEnd = dateRange[1];
    }
  }

  // Get the IMEI and EID values
  const imei = document.getElementById("imei").value;
  const eid = document.getElementById("eid").value;

  // Validate the form data
  if (!firstName) {
    document.getElementById("firstName-error").textContent = window.simActivationMessages.requiredFirstName || "First name is required";
    document.getElementById("firstName-error").style.display = "block";
    return;
  }

  if (!lastName) {
    document.getElementById("lastName-error").textContent = window.simActivationMessages.requiredLastName || "Last name is required";
    document.getElementById("lastName-error").style.display = "block";
    return;
  }

  if (!email) {
    document.getElementById("email-error").textContent = window.simActivationMessages.requiredEmail || "Email is required";
    document.getElementById("email-error").style.display = "block";
    return;
  }

  // Validate email format
  if (!isValidEmail(email)) {
    document.getElementById("email-error").textContent = window.simActivationMessages.invalidEmail || "Please enter a valid email address";
    document.getElementById("email-error").style.display = "block";
    return;
  }

  // Validate the date range
  if (!activationDate) {
    document.getElementById("dateRange-error").textContent = window.simActivationMessages.requiredActivationDate || "Activation date is required";
    document.getElementById("dateRange-error").style.display = "block";
    return;
  }

  // Prepare the request data
  const requestData = {
    simCode,
    firstName,
    lastName,
    email,
    language,
    brandId,
    activationDate,
    activationEnd,
    imei,
    eid
  };

  console.log("New activation requestData:", requestData);

  try {
    // Show loading state
    document.getElementById("submit-activation").textContent = window.simActivationMessages.processing_text || "Processing...";
    document.getElementById("submit-activation").disabled = true;

    // Call the brand-validated new activation endpoint
    const response = await fetch(`${app_url}/public/beachsim-request-activation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestData)
    });

    // Reset button state
    document.getElementById("submit-activation").textContent = window.simActivationMessages.submit_button_text || "Submit";
    document.getElementById("submit-activation").disabled = false;

    // Handle the response
    if (response.ok) {
      const result = await response.json();

      // Store the activation details for potential future use
      window.currentActivationDetails = {
        simCode,
        firstName,
        lastName,
        email,
        activationDate,
        activationEnd,
        imei,
        eid
      };

      // Hide the new activation form
      document.getElementById("new-activation-form").style.display = "none";

      // Display the activation success container
      document.getElementById("activation-success-messages").style.display = "block";

      // Update the displayed information
      document.getElementById("success-activation-sim-code").textContent = simCode;
      document.getElementById("success-activation-name").textContent = `${firstName} ${lastName}`;
      document.getElementById("success-activation-email").textContent = email;

      const formattedActivationDate = formatDate(activationDate);
      const formattedEndDate = activationEnd ? formatDate(activationEnd) : null;

      if (formattedEndDate) {
        document.getElementById("success-activation-dates").textContent = `${formattedActivationDate} - ${formattedEndDate}`;
      } else {
        document.getElementById("success-activation-dates").textContent = `From ${formattedActivationDate}`;
      }

      // Handle IMEI and EID display
      if (imei) {
        document.getElementById("success-activation-imei").textContent = imei;
        document.getElementById("success-activation-imei-container").style.display = "flex";
      } else {
        document.getElementById("success-activation-imei-container").style.display = "none";
      }

      if (eid) {
        document.getElementById("success-activation-eid").textContent = eid;
        document.getElementById("success-activation-eid-container").style.display = "flex";
      } else {
        document.getElementById("success-activation-eid-container").style.display = "none";
      }

      // Show appropriate warnings based on the response
      if (result.showTodayHint) {
        document.getElementById("today-activation-warning").style.display = "block";
      } else {
        document.getElementById("today-activation-warning").style.display = "none";
      }

      if (result.exceedingDurationBy > 0) {
        document.getElementById("exceeding-duration-text").textContent = window.simActivationMessages.exceeding_duration_warning.replace("{days}", result.exceedingDurationBy);
        document.getElementById("duration-warning").style.display = "block";

        if (result.rechargeUrl) {
          document.getElementById("recharge-link").href = result.rechargeUrl;
          document.getElementById("recharge-link-container").style.display = "block";
        } else {
          document.getElementById("recharge-link-container").style.display = "none";
        }
      } else {
        document.getElementById("duration-warning").style.display = "none";
      }

    } else {
      // Handle API errors
      const errorData = await response.json();
      let errorMessage = window.simActivationMessages.genericError || "An error occurred. Please try again.";

      if (errorData.error && errorData.error.message) {
        switch (errorData.error.message) {
          case "SIM_CARD_NOT_FOUND":
            errorMessage = window.simActivationMessages.sim_not_found_error || "SIM card not found.";
            break;
          case "ACTIVATION_DISABLED":
            errorMessage = window.simActivationMessages.activation_disabled_error || "Activation is currently disabled.";
            break;
          case "ACTIVATION_DATE_PAST":
            errorMessage = window.simActivationMessages.activation_date_past_error || "The activation date cannot be in the past.";
            break;
          case "ACTIVATION_DATE_MORE_THAN_TEN_MONTHS_AHEAD":
            errorMessage = window.simActivationMessages.activation_date_future_error || "The activation date cannot be more than 10 months in the future.";
            break;
          case "ACTIVATION_IN_PROGRESS":
            errorMessage = window.simActivationMessages.activation_in_progress_error || "Activation is already in progress.";
            break;
          case "ACTIVATION_DONE":
            errorMessage = window.simActivationMessages.activation_done_error || "Activation has already been completed.";
            break;
          case "IMEI_NOT_VALID":
            errorMessage = window.simActivationMessages.imei_not_valid_error || "The IMEI is not valid.";
            break;
          case "EID_NOT_VALID":
            errorMessage = window.simActivationMessages.eid_not_valid_error || "The EID is not valid.";
            break;
          default:
            errorMessage = errorData.error.message || errorMessage;
        }
      }

      // Show the error message
      document.getElementById("activation-error-message").textContent = errorMessage;
      document.getElementById("activation-errors").style.display = "block";
    }

  } catch (error) {
    // Reset button state
    document.getElementById("submit-activation").textContent = window.simActivationMessages.submit_button_text || "Submit";
    document.getElementById("submit-activation").disabled = false;

    console.error("Network error:", error);
    
    // Show network error message
    document.getElementById("activation-error-message").textContent = window.simActivationMessages.networkError || "Network error. Please check your connection and try again.";
    document.getElementById("activation-errors").style.display = "block";
  }
}

// Handle SIM code form submission
document.getElementById("sim-code-form").addEventListener("submit", async function(event) {
  event.preventDefault();
  
  const simCode = document.getElementById("sim-code").value.trim().replace(/\s/g, "");
  const activationLanguage = document.getElementById("activation-language")?.value || 'EN';
  
  // Persist SIM code in localStorage instead of URL params
  setStoredSimCode(simCode);
  // Remove legacy params if present
  const url = new URL(window.location.href);
  url.searchParams.delete('sim-code');
  url.searchParams.delete('qr');
  window.history.replaceState({}, '', url.toString());
    

  // Show Swiss passport section for both 8941 and 8961
  if (simCode.startsWith('8941') || simCode.startsWith('8961')){
    document.getElementById("activation-form").style.display = "none";
    document.getElementById("travel-sim-form").style.display = "block";
    document.getElementById("swiss-passport-section").style.display = "block";

    // Update passport section text based on SIM type
    const registrationTitle = document.getElementById('passport-registration-title');
    const registrationHint = document.getElementById('passport-registration-hint');
    const documentTypeSelector = document.querySelector('.document-type-selector');
    
    if (simCode.startsWith('8961')) {
      // Update text for Australian SIM
      if (registrationTitle) registrationTitle.textContent = window.simActivationMessages.australianPassportTitle;
      if (registrationHint) registrationHint.textContent = window.simActivationMessages.australianPassportHint;
      if (documentTypeSelector) documentTypeSelector.style.display = 'none';
    } else {
      // Update text for Swiss SIM
      if (registrationTitle) registrationTitle.textContent = window.simActivationMessages.swissPassportTitle;
      if (registrationHint) registrationHint.textContent = window.simActivationMessages.swissPassportHint;
      if (documentTypeSelector) documentTypeSelector.style.display = 'block';
    }

    // Allow only alphnumeric values for first and last names
    const nameFields = ['travelFirstName', 'travelLastName'];

    nameFields.forEach((id) => {
      const input = document.getElementById(id);
      input.addEventListener('input', () => {
        input.value = input.value.replace(/[^A-Za-zÀ-ÿ\-\' ]|[ß×]/g, '');
      });
    });

    // Initialize date of birth field to ensure it's in the past
    initializeDateOfBirthField();

    if (simCode.startsWith('8961')) {
      // Add the counter for Sim Card Number  
      const travelSimInput = document.getElementById("travelSimNumber");
      const travelSimCounter = document.getElementById("travelSimNumber-counter");
      
      if (travelSimInput && travelSimCounter) {
        travelSimInput.addEventListener("input", function () {
          // Remove non-alphanumeric characters
          let cleanedValue = travelSimInput.value.replace(/[^a-zA-Z0-9]/g, "");
      
          // Limit to 20 characters
          if (cleanedValue.length > 20) {
            cleanedValue = cleanedValue.substring(0, 20);
          }
      
          // Set cleaned, trimmed value back to input
          travelSimInput.value = cleanedValue;
      
          // Update counter
          travelSimCounter.textContent = `${cleanedValue.length} / 20`;
        });
      }
    }
 

      // Add the counter for Sim Card Number  
      const travelSimInput = document.getElementById("travelSimNumber");
      const travelSimCounter = document.getElementById("travelSimNumber-counter");
      
      if (travelSimInput && travelSimCounter) {
        travelSimInput.addEventListener("input", function () {
          // Remove non-alphanumeric characters
          let cleanedValue = travelSimInput.value.replace(/[^a-zA-Z0-9]/g, "");
      
          // Limit to 20 characters
          if (cleanedValue.length > 20) {
            cleanedValue = cleanedValue.substring(0, 20);
          }
      
          // Set cleaned, trimmed value back to input
          travelSimInput.value = cleanedValue;
      
          // Update counter
          travelSimCounter.textContent = `${cleanedValue.length} / 20`;
        });

      
      // For 8961, force passport option and hide the selector
      const passportSelector = document.getElementById('passport-selector');
      const idCardSelector = document.getElementById('id-card-selector');
      const documentTypeSelector = document.querySelector('.document-type-selector');
      const passportSection = document.getElementById('passport-upload-section');
      const idCardSection = document.getElementById('id-card-upload-section');
      
      if (passportSelector && idCardSelector && documentTypeSelector && passportSection && idCardSection) {
        // Hide document type selector for 8961
        documentTypeSelector.style.display = 'none';
        
        // Force passport option
        passportSection.style.display = 'block';
        idCardSection.style.display = 'none';
        document.getElementById('swiss-passport-section').setAttribute('data-document-type', 'passport');
      }
    }

    document.getElementById('activation-form').style.display = 'none';
    document.getElementById('travel-sim-form').style.display = 'block';
    
    // Set the SIM number in the travel SIM form
    document.getElementById('travelSimNumber').value = simCode;
  }

  // Process the activation based on SIM code
  processSimActivation(simCode);
});

// On DOM load, prefill the form if activation data exists and check for URL parameters.
document.addEventListener("DOMContentLoaded", function() {
   // Initialize landing page button handlers
   // initLandingPageButtons();
   
   // Initialize GPS phone number counter
   initGpsPhoneNumberCounter();

   // Initialize IMEI/EID numeric counters (new activation + change details forms)
   initNumericCounterField('imei', 'imei-counter', 15);
   initNumericCounterField('eid', 'eid-counter', 32);
   initNumericCounterField('change-details-imei', 'change-details-imei-counter', 15);
   initNumericCounterField('change-details-eid', 'change-details-eid-counter', 32);
   
   // Block special characters (including dashes) in first/last name fields (new activation + change details forms)
   ['firstName', 'lastName', 'change-details-firstName', 'change-details-lastName'].forEach((id) => {
     const input = document.getElementById(id);
     if (input) {
       input.addEventListener('input', () => {
         input.value = input.value.replace(/[^A-Za-zÀ-ÿ\' ]|[ß×]/g, '');
       });
     }
   });
   
   // Initialize date of birth field to ensure it's in the past
   initializeDateOfBirthField();
   
   // If URL contains a SIM code (QR/legacy), process automatically; otherwise just prefill from storage
   if (window.location.search && (window.location.search.includes('sim-code') || window.location.search.includes('qr'))) {
      try {
        var params = new URLSearchParams(window.location.search);
        var codeFromUrl = params.get('qr') || params.get('sim-code') || '';
        if (codeFromUrl) {
          setStoredSimCode(codeFromUrl);
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('sim-code');
          cleanUrl.searchParams.delete('qr');
          window.history.replaceState({}, '', cleanUrl.toString());
          // Keep the activation form visible while processing QR
          const activationForm = document.getElementById('activation-form');
          if (activationForm) activationForm.style.display = 'block';
          const simInput = document.getElementById('sim-code');
          if (simInput) simInput.value = codeFromUrl;
          processSimActivation(codeFromUrl);
          return;
        }
      } catch(e) {}
   }

   // If there is no recognized parameter in the URL, reset stored SIM code
   if (!(window.location.search && (window.location.search.includes('sim-code') || window.location.search.includes('qr')))) {
      clearStoredSimCode();
      const simInput = document.getElementById('sim-code');
      if (simInput) simInput.value = '';
   }
   const activationForm = document.getElementById('activation-form');
   if (activationForm) activationForm.style.display = 'block';
});

// Strips non-numeric characters (including whitespace), enforces maxLength, and
// updates the accompanying counter with a checkmark once the required length is reached.
function updateNumericCounter(input, counter, maxLength) {
  if (!input || !counter) return;

  input.value = input.value.replace(/[^0-9]/g, '').substring(0, maxLength);

  const length = input.value.length;
  const isComplete = length === maxLength;
  counter.textContent = `${length} / ${maxLength}${isComplete ? ' ✓' : ''}`;
  counter.style.color = isComplete ? 'green' : '#666';
}

// Wires up a numeric-only, length-limited field (e.g. IMEI, EID) to its counter.
function initNumericCounterField(inputId, counterId, maxLength) {
  const input = document.getElementById(inputId);
  const counter = document.getElementById(counterId);
  if (!input || !counter) return;

  input.addEventListener('input', function() {
    updateNumericCounter(input, counter, maxLength);
  });

  input.addEventListener('paste', function(e) {
    e.preventDefault();
    const pastedData = (e.clipboardData || window.clipboardData).getData('text');
    input.value = pastedData.replace(/[^0-9]/g, '').substring(0, maxLength);
    updateNumericCounter(input, counter, maxLength);
  });
}

// Initialize the character counter for the GPS phone number field
function initGpsPhoneNumberCounter() {
  const gpsPhoneNumberInput = document.getElementById('gpsPhoneNumber');
  const counter = document.getElementById('gpsPhoneNumber-counter');
  
  if (gpsPhoneNumberInput && counter) {
    gpsPhoneNumberInput.addEventListener('input', function() {
      // Allow only numeric values
      this.value = this.value.replace(/[^0-9]/g, '');
      
      // Limit to 11 characters
      if (this.value.length > 11) {
        this.value = this.value.substring(0, 11);
      }
      
      const length = this.value.length;
      counter.textContent = `${length} / 11`;
      
      // Add visual feedback if the length is correct
      if (length === 11) {
        counter.style.color = 'green';
      } else {
        counter.style.color = 'red';
      }
    });
  }
}

// Handle GPS tracker form submission
function submitGpsActivation(event) {
  event.preventDefault();
  
  // Get form values
  const gpsPhoneNumber = document.getElementById('gpsPhoneNumber').value.trim();
  // const orderNumber = document.getElementById('orderNumber').value.trim();
  const firstName = document.getElementById('gpsFirstName').value.trim();
  const lastName = document.getElementById('gpsLastName').value.trim();
  const email = document.getElementById('gpsEmail').value.trim();
  
  // Validate form
  let isValid = true;
  let errorMessage = '';
  
  // Validate GPS phone number
  if (!gpsPhoneNumber) {
    isValid = false;
    errorMessage = window.simActivationMessages.gpsPhoneRequiredError;
  } else if (gpsPhoneNumber.length !== 11) {
    isValid = false;
    errorMessage = window.simActivationMessages.gpsPhoneLengthError;
  }
  
  // Validate first name
  if (!firstName) {
    isValid = false;
    errorMessage = window.simActivationMessages.requiredFirstName;
  }
  
  // Validate last name
  if (!lastName) {
    isValid = false;
    errorMessage = window.simActivationMessages.requiredLastName;
  }
  
  // Validate email
  if (!email) {
    isValid = false;
    errorMessage = window.simActivationMessages.requiredEmail;
  } else if (!isValidEmail(email)) {
    isValid = false;
    errorMessage = window.simActivationMessages.invalidEmail;
    document.getElementById('gpsEmail-error').textContent = window.simActivationMessages.invalidEmail;
    document.getElementById('gpsEmail-error').style.display = 'block';
  } else {
    document.getElementById('gpsEmail-error').style.display = 'none';
  }
  
  // If form is not valid, show error message
  if (!isValid) {
    document.getElementById('gps-activation-error-message').textContent = errorMessage;
    document.getElementById('gps-activation-errors').style.display = 'block';
    return;
  }
  
  // Clear error messages
  document.getElementById('gps-activation-errors').style.display = 'none';
  
  // Prepare data for submission
  const activationData = {
    gpsPhoneNumber: gpsPhoneNumber,
    // orderNumber: orderNumber,
    gpsFirstName: firstName,
    gpsLastName: lastName,
    gpsEmail: email,
    language: document.getElementById('gps-language').value || 'EN', // Add language parameter
    brandId: parseInt(document.getElementById('gps-brand-id').value || 2) // Add brandId parameter as a number
  };
  
  // Disable submit button to prevent multiple submissions
  document.getElementById('gps-submit-btn').disabled = true;
  
  // Send data to server
  fetch(`${app_url}/public/gps-activation`, {
    method: 'POST',
    // headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(activationData)
  })
  .then(response => response.json())
  .then(result => {
    // Re-enable submit button
    document.getElementById('gps-submit-btn').disabled = false;
    
    if (result.success) {
      // Show success message
      showGpsActivationSuccess(result);
    } else {
      // Show error message
      document.getElementById('gps-activation-error-message').textContent = result.message || 'An error occurred. Please try again.';
      document.getElementById('gps-activation-errors').style.display = 'block';
    }
  })
  .catch(error => {
    // Re-enable submit button
    document.getElementById('gps-submit-btn').disabled = false;
    
    // Show error message
    document.getElementById('gps-activation-error-message').textContent = 'A network error occurred. Please try again.';
    document.getElementById('gps-activation-errors').style.display = 'block';
    console.error('Error:', error);
  });
}

// Show GPS activation success message
function showGpsActivationSuccess(result) {
  // Hide the GPS tracker form
  document.getElementById('gps-tracker-form').style.display = 'none';
  
  // Show the success message container
  document.getElementById('activation-success-messages').style.display = 'block';

  console.log("Showing GPS activation success message");
  
  // Hide the "Change details" link for GPS activations
  const changeDetailsLinks = document.querySelectorAll('a[onclick="showChangeDetailsForm()"]');
  changeDetailsLinks.forEach(link => {
    link.style.display = 'none';
    link.style.visibility = 'hidden';
    link.style.opacity = '0';
    link.style.pointerEvents = 'none';
  });
  console.log("Hidden the 'Change details' links for GPS activation");
  console.log(changeDetailsLinks);
  
  // Populate the success message container with the GPS activation data
  // document.getElementById('success-activation-sim-code').textContent = result.phoneNumber || '';
  // document.getElementById('success-activation-name').textContent = result.name || '';
  // document.getElementById('success-activation-email').textContent = result.email || '';

  document.getElementById('success-activation-sim-code-container').style.display = 'none';
  document.getElementById('success-activation-user-info-container').style.display = 'none';
  
  // Show dates if available
  const datesElement = document.getElementById('success-activation-dates');
  if (datesElement && result.activationDate && result.endDate) {
    datesElement.parentElement.style.display = 'flex';
    datesElement.textContent = `${formatDate(result.activationDate)} until ${formatDate(result.endDate)}`;
  } else if (datesElement) {
    datesElement.parentElement.style.display = 'none';
  }
  
  // Hide IMEI and EID containers
  document.getElementById('success-activation-imei-container').style.display = 'none';
  document.getElementById('success-activation-eid-container').style.display = 'none';
}

// Helper function to validate email
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// Show Lycamobile activation success message
function showLycamobileActivationSuccess(result, activationData) {
  // Hide the Lycamobile form
  document.getElementById('lycamobile-form').style.display = 'none';
  
  // Show the success message container
  document.getElementById('activation-success-messages').style.display = 'block';
  
  // Hide the "Change details" link only for Swiss/Australian SIM cards
  const changeDetailsLinks = document.querySelectorAll('a[onclick="showChangeDetailsForm()"]');
  if (activationData.simNumber) {
    // Only hide for Swiss/Australian SIMs (starting with 894 or 896)
    if (activationData.simNumber.startsWith('8941') || activationData.simNumber.startsWith('8961') || activationData.simNumber.startsWith('372')) {
      console.log("Hiding 'Change details' button for Swiss/Australian/GPS SIM:", activationData.simNumber);
      changeDetailsLinks.forEach(link => {
        link.style.display = 'none';
        link.style.visibility = 'hidden';
        link.style.opacity = '0';
        link.style.pointerEvents = 'none';
      });
    } else {
      // Show the button for other SIM types
      console.log("Showing 'Change details' button for other SIM types:", activationData.simNumber);
      changeDetailsLinks.forEach(link => {
        link.style.display = 'inline-block';
        link.style.visibility = 'visible';
        link.style.opacity = '1';
        link.style.pointerEvents = 'auto';
      });
    }
  }
  
  // Populate the success message container with the activation data
  document.getElementById('success-activation-sim-code').textContent = activationData.simNumber || '';
  document.getElementById('success-activation-name').textContent = activationData.name || '';
  document.getElementById('success-activation-email').textContent = activationData.email || '';
  
  // Show the dates section
  const datesElement = document.getElementById('success-activation-dates');
  if (datesElement) {
    datesElement.parentElement.style.display = 'flex';
    datesElement.textContent = `${formatDate(activationData.activationDate)} until ${formatDate(activationData.endDate)}`;
  }
  
  // Hide IMEI and EID containers
  document.getElementById('success-activation-imei-container').style.display = 'none';
  document.getElementById('success-activation-eid-container').style.display = 'none';
  
  // Show appropriate warning messages
  if (result.showTodayHint) {
    document.getElementById('today-activation-warning').style.display = 'flex';
  } else {
    document.getElementById('today-activation-warning').style.display = 'none';
  }
  
  // Hide duration warning by default
  document.getElementById('duration-warning').style.display = 'none';
  
  // Update success message title based on SIM type
  const successTitle = document.getElementById('success-activation-title');
  if (successTitle) {
    if (activationData.simType === 'travel') {
      successTitle.textContent = window.simActivationMessages.travel_sim_activation_title || 'Travel SIM Card Activation Scheduled';
    } else if (activationData.simType === 'lebara') {
      successTitle.textContent = window.simActivationMessages.lebara_sim_activation_title || 'Lebara SIM Card Activation Scheduled';
    } else {
      successTitle.textContent = window.simActivationMessages.lycamobile_sim_activation_title || 'Lycamobile SIM Card Activation Scheduled';
    }
  }
}

// Update showSuccessMessages function to populate the success container with user info
function showSuccessMessages(result,activationData) {
  // Hide other containers
  document.getElementById("new-activation-form").style.display = "none";
  document.getElementById("activation-details-container").style.display = "none";

  // Show the success messages container
  const successContainer = document.getElementById("activation-success-messages");
  successContainer.style.display = "block";

  // Populate user information in the success container
  // const data = result.requestActivationData || {};
  document.getElementById("success-activation-sim-code").textContent = activationData.simCode || "";
  document.getElementById("success-activation-name").textContent = `${activationData.firstName || ""} ${activationData.lastName || ""}`.trim();
  document.getElementById("success-activation-email").textContent = activationData.email || "—";
  document.getElementById("success-activation-dates").textContent = 
    `${formatDate(activationData.activationDate)} until ${formatDate(activationData.activationEnd)}`;

  // Update IMEI if present
  const imeiContainer = document.getElementById("success-activation-imei-container");
  if (activationData.imei) {
    document.getElementById("success-activation-imei").textContent = activationData.imei;
    imeiContainer.style.display = "flex";
  } else {
    imeiContainer.style.display = "none";
  }

  // Update EID if present
  const eidContainer = document.getElementById("success-activation-eid-container");
  if (activationData.eid) {
    document.getElementById("success-activation-eid").textContent = 
      activationData.eid.replace(/(.{4})/g, "$1 ").trim();
    eidContainer.style.display = "flex";
  } else {
    eidContainer.style.display = "none";
  }

  // Handle duration warning
  const durationWarning = document.getElementById("duration-warning");
  if (result.exceedingDurationBy) {
    durationWarning.style.display = "flex";
    const exceedingText = document.getElementById("exceeding-duration-text");
    const days = result.exceedingDurationBy;
    
    // Get the warning text from a data attribute that would be set in the Liquid template
    let warningTemplate = exceedingText.getAttribute("data-warning-template") || 
      "The activation period exceeds your booking duration. Your SIM card will be deactivated <days> day(s) before the requested end date.";
    
    // Replace the <days> placeholder with the actual number
    let warningText = warningTemplate.replace("<days>", days);
    
    // Replace day(s) with the correct singular/plural form if needed
    warningText = warningText.replace("day(s)", days > 1 ? "days" : "day");
    
    exceedingText.textContent = warningText;
    
    const rechargeLinkContainer = document.getElementById("recharge-link-container");
    if (result.allowRechargeLoadings && result.rechargeUrl) {
      rechargeLinkContainer.style.display = "block";
      document.getElementById("recharge-link").href = result.rechargeUrl;
    } else {
      rechargeLinkContainer.style.display = "none";
    }
  } else {
    durationWarning.style.display = "none";
  }

  // Handle today activation warning
  const todayWarning = document.getElementById("today-activation-warning");
  todayWarning.style.display = result.showTodayHint ? "flex" : "none";
}

function clearSuccessMessages() {
  // Reset all success message elements
  const successElements = [
    "success-activation-sim-code",
    "success-activation-name",
    "success-activation-email",
    "success-activation-dates",
    "success-activation-imei",
    "success-activation-eid"
  ];
  
  successElements.forEach(function(id) {
    const element = document.getElementById(id);
    if (element) element.textContent = "";
  });
  
  // Hide optional containers
  const optionalContainers = [
    "success-activation-imei-container",
    "success-activation-eid-container",
    "activation-success-messages"
  ];
  
  optionalContainers.forEach(function(id) {
    const element = document.getElementById(id);
    if (element) element.style.display = "none";
  });
}

// Call clearAllMessages when relevant navigation actions occur
document.addEventListener('DOMContentLoaded', function() {
  // Add event listeners to navigation elements
  const navigationElements = document.querySelectorAll('a[href="#"], .btn[type="reset"], #reset-activation');
  
  navigationElements.forEach(function(element) {
    element.addEventListener('click', function() {
      clearAllMessages();
    });
  });
});

// Add required attribute to required fields and set up blur event handlers
document.addEventListener('DOMContentLoaded', function() {
  // Fields that should be required
  const requiredFields = [
    'firstName',
    'lastName',
    'email',
    'activationDate'
  ];
  
  // Add required attribute to each required field
  requiredFields.forEach(function(fieldId) {
    const field = document.getElementById(fieldId);
    if (field) {
      field.setAttribute('required', 'required');
      
      // Add blur event listener to clear custom error messages when user navigates away
      field.addEventListener('blur', function() {
        // Clear any custom error styling
        this.classList.remove('input-error');
        
        // Clear any error message element associated with this field
        const errorElement = document.getElementById(`${fieldId}-error`);
        if (errorElement) {
          errorElement.style.display = 'none';
        }
      });
    }
  });
  
  // Make activationEnd optional (no required attribute)
  const activationEndField = document.getElementById('activationEnd');
  if (activationEndField) {
    activationEndField.removeAttribute('required');
  }
});

// Show error message in the form
function showErrorMessage(message) {
  const errorContainer = document.getElementById('travel-sim-activation-errors');
  if (errorContainer) {
    errorContainer.textContent = message;
    errorContainer.style.display = 'block';
    errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function validateEmail(email) {
  if (!email || !isValidEmail(email)) {
    document.getElementById('gpsEmail-error').textContent = window.simActivationMessages.invalidEmail;
    document.getElementById('gpsEmail-error').style.display = 'block';
    return false;
  }
  document.getElementById('gpsEmail-error').style.display = 'none';
  return true;
}

// Submit Travel SIM activation form
async function submitTravelSimActivation(event) {
    event.preventDefault();
    clearAllMessages();

    // Get form elements
    const form = event.target;
    const firstName = form.querySelector('#travelFirstName').value.trim();
    const lastName = form.querySelector('#travelLastName').value.trim();
    const email = form.querySelector('#travelEmail').value.trim();
    const simNumber = form.querySelector('#travelSimNumber').value.trim();
    const country = form.querySelector('#travelCountry').value.trim();
    const dateOfBirth = form.querySelector('#travelDob').value.trim();
    const street = form.querySelector('#travelStreet').value.trim();
    const city = form.querySelector('#travelCity').value.trim();
    const zipCode = form.querySelector('#travelZip').value.trim();
    const passportNumber = form.querySelector('#travelPassport').value.trim();
    const termsCheckbox = form.querySelector('#travelTerms');
    const language = document.getElementById('gps-language').value || 'EN';
    const arrivalDate = form.querySelector('#travelArrivalDate')?.value.trim();
    const activationDate = form.querySelector('#travelActivationDate')?.value.trim();

    // For Australian SIM cards, make sure ID card is hidden and passport is shown
    if (simNumber.startsWith('8961')) {
        // Validate arrival date for Australian SIMs
        if (!arrivalDate) {
            showErrorMessage(window.simActivationMessages.requiredArrivalDate);
            return;
        }

        const arrivalDateObj = new Date(arrivalDate);
        const today = new Date();
        if (isNaN(arrivalDateObj) || arrivalDateObj < today) {
            showErrorMessage(window.simActivationMessages.arrivalDatePastError);
            return;
        }

        // Validate activation date
        if (!activationDate) {
            showErrorMessage(window.simActivationMessages.requiredActivationDate);
            return;
        }

        const activationDateObj = new Date(activationDate);
        if (isNaN(activationDateObj) || activationDateObj < today) {
            showErrorMessage(window.simActivationMessages.activationDatePastError);
            return;
        }

        // Ensure activation date is not before arrival date
        if (activationDateObj < arrivalDateObj) {
            showErrorMessage(window.simActivationMessages.activationBeforeArrivalError);
            return;
        }

        // Hide ID card section and show passport section
        const idCardSection = document.getElementById('id-card-upload-section');
        const passportSection = document.getElementById('passport-upload-section');
        const documentTypeSelector = document.querySelector('.document-type-selector');
        const passportSelector = document.getElementById('passport-selector');
        const idCardSelector = document.getElementById('id-card-selector');
        
        // Reset ID card upload fields
        const idFrontInput = document.getElementById('travelIdFront');
        const idBackInput = document.getElementById('travelIdBack');
        if (idFrontInput) idFrontInput.value = '';
        if (idBackInput) idBackInput.value = '';
        
        // Hide ID card section and document type selector, show passport section
        if (documentTypeSelector) documentTypeSelector.style.display = 'none';
        if (idCardSection) idCardSection.style.display = 'none';
        if (passportSection) passportSection.style.display = 'block';
        
        // Set correct active selector
        if (passportSelector) passportSelector.classList.add('active');
        if (idCardSelector) idCardSelector.classList.remove('active');
    }

    if (!dateOfBirth) {
        showErrorMessage(window.simActivationMessages.requiredDob);
        return;
    }
    
    // Validate that date of birth is in the past
    const selectedDate = new Date(dateOfBirth);
    const currentDate = new Date();
    if (isNaN(selectedDate) || selectedDate > currentDate) {
        showErrorMessage(window.simActivationMessages.dobPastError);
        return;
    }

    if (!termsCheckbox || !termsCheckbox.checked) {
        showErrorMessage(window.simActivationMessages.termsRequiredError);
        return;
    }

    // Calculate end date based on activation date for Australian SIMs
    let formattedEndDate;
    if (simNumber.startsWith('8961') && activationDate) {
        // Use the selected activation date as the base for endDate calculation
        const activationDateObj = new Date(activationDate);
        const endDate = new Date(activationDateObj);
        endDate.setDate(activationDateObj.getDate() + 30); // 30 days after activation date
        formattedEndDate = endDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    } else {
        // For other SIM types, use current date + 30 days
        const today = new Date();
        const endDate = new Date(today);
        endDate.setDate(today.getDate() + 30);
        formattedEndDate = endDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    }

    // Prepare form data
    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', email);
    formData.append('simNumber', simNumber);
    formData.append('country', country);
    formData.append('dateOfBirth', dateOfBirth);
    formData.append('street', street);
    formData.append('city', city);
    formData.append('zipCode', zipCode);
    formData.append('passportNumber', passportNumber);
    formData.append('endDate', formattedEndDate);
    formData.append('waiver', 'true');
    formData.append('brandId', '2');
    formData.append('language', language);

    if (simNumber.startsWith('8961')) {
        formData.append('arrivalDate', arrivalDate);
        formData.append('activationDate', activationDate);
    }
    
    const swissAgreementCheckbox = form.querySelector('#swissAgreement');
    if (swissAgreementCheckbox) {
        formData.append('swissAgreement', swissAgreementCheckbox.checked.toString());
    }

    // Determine SIM type and document requirements
    if (simNumber.startsWith('8941')) {
        formData.append('simType', 'swiss');
        
        const passportSelector = document.getElementById('passport-selector');
        const idCardSelector = document.getElementById('id-card-selector');
        
        // Check which selector is active
        if (!passportSelector.classList.contains('active') && !idCardSelector.classList.contains('active')) {
            showErrorMessage(window.simActivationMessages.documentTypeError);
            return;
        }

        if (passportSelector.classList.contains('active')) {
            const swissPassportFile = document.getElementById('swissPassport').files[0];
            if (!swissPassportFile) {
                showErrorMessage(window.simActivationMessages.uploadPassportRequiredError);
                return;
            }
            formData.append('documentType', 'passport');
            formData.append('swissPassport', swissPassportFile);
        } else if (idCardSelector.classList.contains('active')) {
            const idFrontFile = document.getElementById('travelIdFront').files[0];
            const idBackFile = document.getElementById('travelIdBack').files[0];
            if (!idFrontFile || !idBackFile) {
                showErrorMessage(window.simActivationMessages.uploadIdRequiredError);
                return;
            }
            formData.append('documentType', 'idCard');
            formData.append('travelIdFront', idFrontFile);
            formData.append('travelIdBack', idBackFile);
        }
    } else if (simNumber.startsWith('8961')) {
        formData.append('simType', 'australian');
        
        const swissPassportFile = document.getElementById('swissPassport').files[0];
        if (!swissPassportFile) {
            showErrorMessage(window.simActivationMessages.uploadPassportRequiredError);
            return;
        }
        formData.append('documentType', 'passport');
        formData.append('swissPassport', swissPassportFile); // Use the swissPassport field for both
    } else {
        showErrorMessage(window.simActivationMessages.invalidSimNumberError);
        return;
    }

    try {
        const response = await fetch(`${app_url}/public/swiss-aus-activation`, {
            method: 'POST',
            // Note: Don't set Content-Type header for FormData, browser will add it with boundary
            body: formData
        });

        if (response.ok) {
            const result = await response.json();
            if (result.success) {
                showTravelSimActivationSuccess();
            } else {
                showErrorMessage(result.message || 'An error occurred during activation.');
            }
        } else {
            // Try to get error details from response
            try {
                const errorDetails = await response.json();
                showErrorMessage(errorDetails.message || `Error (${response.status}): An error occurred during activation.`);
            } catch (jsonError) {
                showErrorMessage(`Error (${response.status}): An error occurred during activation.`);
            }
        }
    } catch (error) {
        console.error('Error:', error);
        showErrorMessage('A network error occurred. Please try again.');
    }
}

// Show Travel SIM activation success message
function showTravelSimActivationSuccess() {
    // Hide the form
    const form = document.getElementById('travel-sim-form');
    if (form) {
        form.style.display = 'none';
    }
    
    // Check the SIM type - only hide the "Change details" link for Swiss/Australian SIMs
    const travelSimNumberInput = document.getElementById('travelSimNumber');
    const simNumber = travelSimNumberInput ? travelSimNumberInput.value : '';
    const changeDetailsLinks = document.querySelectorAll('a[onclick="showChangeDetailsForm()"]');
    
    if (simNumber) {
        if (simNumber.startsWith('8941') || simNumber.startsWith('8961')) {
            // Hide for Swiss/Australian SIMs
            console.log("Hiding 'Change details' button for Swiss/Australian SIM:", simNumber);
            changeDetailsLinks.forEach(link => {
                link.style.display = 'none';
                link.style.visibility = 'hidden';
                link.style.opacity = '0';
                link.style.pointerEvents = 'none';
            });
        } else {
            // Show for other travel SIMs
            console.log("Showing 'Change details' button for other travel SIM:", simNumber);
            changeDetailsLinks.forEach(link => {
                link.style.display = 'inline-block';
                link.style.visibility = 'visible';
                link.style.opacity = '1';
                link.style.pointerEvents = 'auto';
            });
        }
    }
    
    // Show the success message container
    document.getElementById('activation-success-messages').style.display = 'block';
    
    // Get the SIM number to check if it's a Swiss SIM
    const travelSimNum = document.getElementById('travelSimNumber').value;
    const isSwissSim = travelSimNum.startsWith('8941');
    const isAusSim = travelSimNum.startsWith('8961');
    
    // Populate the success message container
    document.getElementById('success-activation-sim-code').textContent = document.getElementById('travelSimNumber').value || '';
    document.getElementById('success-activation-name').textContent = 
        (document.getElementById('travelFirstName').value + ' ' + document.getElementById('travelLastName').value).trim() || '';
    document.getElementById('success-activation-email').textContent = document.getElementById('travelEmail').value || '';
    
    // Show dates if available
    const activationDate = new Date();
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 30); // Default to 30 days from now
    
    const datesElement = document.getElementById('success-activation-dates');
    if (datesElement) {
        datesElement.parentElement.style.display = 'flex';
        datesElement.textContent = `${formatDate(activationDate.toISOString().split('T')[0])} until ${formatDate(endDate.toISOString().split('T')[0])}`;
    }
    
    // Hide IMEI and EID containers
    document.getElementById('success-activation-imei-container').style.display = 'none';
    document.getElementById('success-activation-eid-container').style.display = 'none';
    
    // Show Swiss-specific message if it's a Swiss SIM
    const swissMessage = document.getElementById('swiss-activation-message');
    if (swissMessage) {
        swissMessage.style.display = isSwissSim ? 'block' : 'none';
    }
    
    // Show Australian-specific message if it's an Australian SIM
    const ausMessage = document.getElementById('aus-activation-message');
    if (ausMessage) {
        ausMessage.style.display = isAusSim ? 'block' : 'none';
    }
}

// Function to initialize Swiss file uploads
function initializeSwissFileUploads() {
    // Initialize document type selector
    initializeSwissDocumentSelector();
    
    // Initialize file upload display for passport
    const passportInput = document.getElementById('swissPassport');
    const passportName = document.getElementById('swissPassportName');
    
    if (passportInput && passportName) {
        // Remove any existing event listeners
        passportInput.removeEventListener('change', handlePassportFileChange);
        
        // Add new event listener
        passportInput.addEventListener('change', handlePassportFileChange);
        
        // Check for existing files
        if (passportInput.files && passportInput.files.length > 0) {
            passportName.textContent = passportInput.files[0].name;
        } else {
            passportName.textContent = 'No file chosen';
        }
    }
    
    // Initialize file upload display for ID card front
    const idFrontInput = document.getElementById('travelIdFront');
    const idFrontName = document.getElementById('travelIdFrontName');
    
    if (idFrontInput && idFrontName) {
        // Remove any existing event listeners
        idFrontInput.removeEventListener('change', handleIdFrontFileChange);
        
        // Add new event listener
        idFrontInput.addEventListener('change', handleIdFrontFileChange);
        
        // Check for existing files
        if (idFrontInput.files && idFrontInput.files.length > 0) {
            idFrontName.textContent = idFrontInput.files[0].name;
        } else {
            idFrontName.textContent = 'No file chosen';
        }
    }
    
    // Initialize file upload display for ID card back
    const idBackInput = document.getElementById('travelIdBack');
    const idBackName = document.getElementById('travelIdBackName');
    
    if (idBackInput && idBackName) {
        // Remove any existing event listeners
        idBackInput.removeEventListener('change', handleIdBackFileChange);
        
        // Add new event listener
        idBackInput.addEventListener('change', handleIdBackFileChange);
        
        // Check for existing files
        if (idBackInput.files && idBackInput.files.length > 0) {
            idBackName.textContent = idBackInput.files[0].name;
        } else {
            idBackName.textContent = 'No file chosen';
        }
    }
}

// Separate handler functions for each file input
function handlePassportFileChange() {
    const passportName = document.getElementById('swissPassportName');
    if (this.files && this.files.length > 0) {
        passportName.textContent = this.files[0].name;
        console.log('Passport file selected:', this.files[0].name);
    } else {
        passportName.textContent = window.simActivationMessages.no_file_chosen_text || 'No file chosen';
        console.log('No passport file selected');
    }
}

function handleIdFrontFileChange() {
    const idFrontName = document.getElementById('travelIdFrontName');
    if (this.files && this.files.length > 0) {
        idFrontName.textContent = this.files[0].name;
        console.log('ID front file selected:', this.files[0].name);
    } else {
        idFrontName.textContent = window.simActivationMessages.no_file_chosen_text || 'No file chosen';
        console.log('No ID front file selected');
    }
}

function handleIdBackFileChange() {
    const idBackName = document.getElementById('travelIdBackName');
    if (this.files && this.files.length > 0) {
        idBackName.textContent = this.files[0].name;
        console.log('ID back file selected:', this.files[0].name);
    } else {
        idBackName.textContent = window.simActivationMessages.no_file_chosen_text || 'No file chosen';
        console.log('No ID back file selected');
    }
}

// Function to initialize Swiss document type selectors
function initializeSwissDocumentSelector() {
    const passportSelector = document.getElementById('passport-selector');
    const idCardSelector = document.getElementById('id-card-selector');
    const passportSection = document.getElementById('passport-upload-section');
    const idCardSection = document.getElementById('id-card-upload-section');
    
    if (passportSelector && idCardSelector) {
        // Set initial state
        passportSection.style.display = 'block';
        idCardSection.style.display = 'none';
        passportSelector.classList.add('active');
        idCardSelector.classList.remove('active');
        
        // Add click handlers
        passportSelector.addEventListener('click', function() {
            passportSection.style.display = 'block';
            idCardSection.style.display = 'none';
            passportSelector.classList.add('active');
            idCardSelector.classList.remove('active');
        });
        
        idCardSelector.addEventListener('click', function() {
            passportSection.style.display = 'none';
            idCardSection.style.display = 'block';
            passportSelector.classList.remove('active');
            idCardSelector.classList.add('active');
        });
    }
}

function addCloseButton(instance) {
    // Remove any existing close button(s) first (defensive: clears all, not just the first)
    instance.calendarContainer.querySelectorAll('.flatpickr-close-button').forEach(function(btn) {
        btn.remove();
    });

    // Create the close button
    const closeBtn = document.createElement('div');
    closeBtn.className = 'flatpickr-close-button';
    closeBtn.innerHTML = '&times;';
    closeBtn.setAttribute('role', 'button');
    closeBtn.setAttribute('tabindex', '0');
    
    // Use a direct and robust close approach
    closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        console.log('Close button clicked');
        
        // Directly hide the calendar container
        instance.calendarContainer.style.display = 'none';
        
        // Set internal state
        instance.isOpen = false;
        
        // Try multiple close approaches
        try {
            instance.close();
        } catch (err) {
            console.log('Error when closing calendar:', err);
        }
        
        // Fire change event to ensure any handlers run
        instance.element.dispatchEvent(new Event('change'));
        
        // Remove open classes
        instance.calendarContainer.classList.remove('open');
        document.body.classList.remove('flatpickr-open');
        
        // If all else fails, use a timeout to hide
        setTimeout(function() {
            instance.calendarContainer.style.display = 'none';
            instance.isOpen = false;
        }, 100);
    });
    
    // Also add keyboard support for accessibility
    closeBtn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            closeBtn.click();
        }
    });
    
    // Append to the outer calendar popup (not the inner .flatpickr-month box,
    // which flatpickr clips with overflow:hidden and sizes to fit just the
    // month label — an absolutely positioned button there gets cut off).
    // This also keeps the button correctly in the true top-right corner when
    // 2 months are shown side by side on desktop.
    instance.calendarContainer.appendChild(closeBtn);

    // On mobile the next-month arrow is docked to the same top-right corner
    // (right: 5px, width: 34px), so push the close button further left to
    // clear it. On desktop the arrows sit outside the popup (negative offset)
    // so the button can sit flush in the corner.
    const isMobileView = window.innerWidth < 768;
    
    // Ensure the button is visible and positioned correctly
    closeBtn.style.position = 'absolute';
    closeBtn.style.top = '15px';
    closeBtn.style.right = isMobileView ? '55px' : '15px';
    closeBtn.style.width = '36px';
    closeBtn.style.height = '36px';
    closeBtn.style.display = 'flex';
    closeBtn.style.alignItems = 'center';
    closeBtn.style.justifyContent = 'center';
    closeBtn.style.cursor = 'pointer';
    closeBtn.style.zIndex = '10';
    closeBtn.style.fontSize = '30px';
    closeBtn.style.background = '#f5f5f5';
    closeBtn.style.borderRadius = '50%';
    closeBtn.style.border = '1px solid #ddd';
    closeBtn.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
}

function hideNavigationArrows(instance) {
    if (!instance || !instance.calendarContainer) return;
    
    const prevMonthButton = instance.calendarContainer.querySelector('.flatpickr-prev-month');
    const nextMonthButton = instance.calendarContainer.querySelector('.flatpickr-next-month');
    
    if (prevMonthButton) prevMonthButton.style.display = 'none';
    if (nextMonthButton) nextMonthButton.style.display = 'none';
}

function addDoneButtonToCalendar(instance) {
    // Check if the button already exists to avoid duplicates
    const existingButton = instance.calendarContainer.querySelector('.flatpickr-mobile-done-btn');
    if (existingButton) {
        existingButton.remove();
    }
    
    // Create the done button
    const doneButton = document.createElement('button');
    doneButton.className = 'flatpickr-mobile-done-btn';
    doneButton.textContent = window.simActivationMessages.done_button_text || 'Done';
    doneButton.setAttribute('type', 'button'); // Ensure it's treated as a button
    
    // Add click handler with a more direct approach
    doneButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        console.log('Done button clicked');
        
        // Directly hide the calendar container
        instance.calendarContainer.style.display = 'none';
        
        // Set internal state
        instance.isOpen = false;
        instance._hidePrevMonthArrow = instance._initialDate;
        
        // Try multiple close approaches
        try {
            instance.close();
        } catch (err) {
            console.log('Error when closing calendar:', err);
        }
        
        // Fire change event to ensure any handlers run
        instance.element.dispatchEvent(new Event('change'));
        
        // Remove open classes
        instance.calendarContainer.classList.remove('open');
        document.body.classList.remove('flatpickr-open');
        
        // If all else fails, use a timeout to hide
        setTimeout(function() {
            instance.calendarContainer.style.display = 'none';
            instance.isOpen = false;
        }, 100);
    });
    
    // Style the button to ensure it's visible and looks good
    doneButton.style.position = 'sticky';
    doneButton.style.bottom = '0';
    doneButton.style.left = '0';
    doneButton.style.right = '0';
    doneButton.style.width = '100%';
    doneButton.style.padding = '15px';
    doneButton.style.background = '#1a73e8';
    doneButton.style.color = 'white';
    doneButton.style.border = 'none';
    doneButton.style.fontWeight = 'bold';
    doneButton.style.fontSize = '16px';
    doneButton.style.cursor = 'pointer';
    doneButton.style.zIndex = '100';
    doneButton.style.textAlign = 'center';
    
    // Append to the calendar container
    instance.calendarContainer.appendChild(doneButton);
}

function fixCalendarLayout(instance) {
    if (!instance) return;
    
    // Wait a moment to ensure the DOM is fully rendered
    setTimeout(() => {
        // Force the calendar to be visible first, before applying styles
        instance.calendarContainer.style.display = 'flex';
        instance.calendarContainer.style.flexDirection = 'column';
        
        // Fix the calendar width issue
        const calendarContainer = instance.calendarContainer;
        calendarContainer.style.width = '100%';
        calendarContainer.style.minWidth = '100%';
        calendarContainer.style.maxWidth = '100%';
        
        // Force a minimum height on the calendar to ensure it fills the screen
        calendarContainer.style.minHeight = '100%';
        
        // Fix the innerContainer width
        const innerContainer = calendarContainer.querySelector('.flatpickr-innerContainer');
        if (innerContainer) {
            innerContainer.style.width = '100%';
            innerContainer.style.minWidth = '100%';
            innerContainer.style.maxWidth = '100%';
        }
        
        // Fix the rContainer width
        const rContainer = calendarContainer.querySelector('.flatpickr-rContainer');
        if (rContainer) {
            rContainer.style.width = '100%';
            rContainer.style.minWidth = '100%';
            rContainer.style.maxWidth = '100%';
        }
        
        // Fix the days container width
        const daysContainer = calendarContainer.querySelector('.flatpickr-days');
        if (daysContainer) {
            daysContainer.style.width = '100%';
            daysContainer.style.minWidth = '100%';
            daysContainer.style.maxWidth = '100%';
            
            // Ensure all day containers have proper width
            const dayContainers = daysContainer.querySelectorAll('.dayContainer');
            dayContainers.forEach(container => {
                container.style.width = '100%';
                container.style.minWidth = '100%';
                container.style.maxWidth = '100%';
            });
        }
        
        // Fix specific mobile layout issues
        if (window.innerWidth < 768) {
            // Only show the first weekday container and hide the rest
            const weekdayContainers = calendarContainer.querySelectorAll('.flatpickr-weekdaycontainer');
            if (weekdayContainers.length > 0) {
                const firstContainer = weekdayContainers[0];
                firstContainer.style.display = 'flex';
                firstContainer.style.width = '100%';
                
                for (let i = 1; i < weekdayContainers.length; i++) {
                    weekdayContainers[i].style.display = 'none';
                }
            }
            
            // Fix month display issues
            const monthContainers = calendarContainer.querySelectorAll('.flatpickr-month');
            monthContainers.forEach((month, index) => {
                // Make sure month name is visible
                const currentMonth = month.querySelector('.flatpickr-current-month');
                if (currentMonth) {
                    currentMonth.style.left = '0';
                    currentMonth.style.width = '100%';
                    currentMonth.style.padding = '0 40px';
                    currentMonth.style.textAlign = 'center';
                    currentMonth.style.display = 'flex';
                    currentMonth.style.justifyContent = 'center';
                    
                    // Fix month name and year display
                    const monthName = currentMonth.querySelector('.cur-month');
                    const yearInput = currentMonth.querySelector('.numInputWrapper');
                    if (monthName) {
                        monthName.style.display = 'inline-block';
                        monthName.style.marginRight = '5px';
                    }
                    if (yearInput) {
                        yearInput.style.display = 'inline-block';
                    }
                }
            });
            
            // Ensure weekday names display correctly
            const weekdays = calendarContainer.querySelectorAll('.flatpickr-weekday');
            weekdays.forEach(weekday => {
                weekday.style.fontSize = '14px';
                weekday.style.fontWeight = 'bold';
                weekday.style.color = '#333';
                weekday.style.display = 'block';
                weekday.style.textAlign = 'center';
                weekday.style.width = '14.28%';
            });
            
            // Ensure navigation arrows are positioned correctly
            const prevMonth = calendarContainer.querySelector('.flatpickr-prev-month');
            const nextMonth = calendarContainer.querySelector('.flatpickr-next-month');
            
            if (prevMonth) {
                prevMonth.style.display = 'block';
                prevMonth.style.left = '5px';
                prevMonth.style.top = '15px';
            }
            
            if (nextMonth) {
                nextMonth.style.display = 'block';
                nextMonth.style.right = '45px'; // Make room for close button
                nextMonth.style.top = '15px';
            }
            
            // Make sure close and done buttons are properly positioned
            ensureButtonsPresent(instance);
        }
    }, 50);
}

function ensureButtonsPresent(instance) {
    // Make sure we have a close button
    if (!instance.calendarContainer.querySelector('.flatpickr-close-button')) {
        addCloseButton(instance);
    }
    
    // Make sure we have a done button
    if (!instance.calendarContainer.querySelector('.flatpickr-mobile-done-btn')) {
        addDoneButtonToCalendar(instance);
    }
}

// Function to initialize SIM code validation with dynamic pattern based on prefix
function initSimCodeValidation() {
    const simCodeInput = document.getElementById('sim-code');
    if (!simCodeInput) return;

    const M = window.simActivationMessages || {};

    // Whether the field has been left at least once — feedback colours stay neutral
    // until then so we don't yell at the user mid-typing.
    let touched = false;

    // Single source of truth for the per-SIM-type requirements. Drives the checklist,
    // the counter denominator and the submit-time validation so they can never disagree.
    function getRulesForCode(raw) {
        const value = (raw || '').trim();
        const len = value.length;
        const isDigits = /^[0-9]+$/.test(value);
        const isAlnum = /^[A-Za-z0-9]+$/.test(value);

        if (value.startsWith('372')) {
            return {
                denominator: 11,
                rules: [
                    { key: 'length', label: M.sim_rule_gps_length || 'Exactly 11 characters', pass: len === 11 },
                    { key: 'charset', label: M.sim_rule_gps_charset || 'Digits only (0-9)', pass: isDigits }
                ]
            };
        }
        if (value.startsWith('8941') || value.startsWith('8961')) {
            return {
                denominator: 20,
                rules: [
                    { key: 'length', label: M.sim_rule_fixed_length || 'Exactly 20 characters', pass: len === 20 },
                    { key: 'charset', label: M.sim_rule_alnum || 'Numbers or alphanumeric only', pass: isAlnum }
                ]
            };
        }
        return {
            denominator: 22,
            rules: [
                { key: 'length', label: M.sim_rule_general_length || 'Between 8 and 22 characters', pass: len >= 8 && len <= 22 },
                { key: 'charset', label: M.sim_rule_alnum || 'Numbers or alphanumeric only', pass: isAlnum }
            ]
        };
    }

    // Repaint counter, requirements list and field state for the current value.
    // Positive feedback (green ticks, valid outline) is always live so progress is
    // visible while typing — important on mobile where the field is rarely blurred.
    // Negative feedback (red ✗, red outline) only shows once `showState` is true,
    // i.e. after the first blur or a failed "Next", so we don't punish mid-typing.
    // Returns whether every rule currently passes.
    function refresh(showState) {
        const input = document.getElementById('sim-code');
        if (!input) return false;
        const value = input.value.trim();
        const { denominator, rules } = getRulesForCode(value);
        const hasValue = value.length > 0;
        const showFail = showState && hasValue;

        const counter = document.getElementById('sim-code-counter');
        if (counter) counter.textContent = `${value.length} / ${denominator}`;

        const list = document.getElementById('sim-code-requirements');
        let allPass = true;
        if (list) {
            rules.forEach((rule) => {
                if (!rule.pass) allPass = false;
                let li = list.querySelector('li[data-rule="' + rule.key + '"]');
                if (!li) {
                    li = document.createElement('li');
                    li.setAttribute('data-rule', rule.key);
                    li.innerHTML = '<span class="rule-icon" aria-hidden="true"></span><span class="rule-text"></span>';
                    list.appendChild(li);
                }
                li.querySelector('.rule-text').textContent = rule.label;
                const pass = hasValue && rule.pass;
                const fail = showFail && !rule.pass;
                li.classList.toggle('is-pass', pass);
                li.classList.toggle('is-fail', fail);
            });
            // Drop stale <li>s left over from a different detected SIM type.
            Array.prototype.slice.call(list.querySelectorAll('li[data-rule]')).forEach((li) => {
                if (!rules.some((r) => r.key === li.getAttribute('data-rule'))) li.remove();
            });
        }

        const showValid = hasValue && allPass;
        const showInvalid = showFail && !allPass;
        input.classList.toggle('is-valid', showValid);
        input.classList.toggle('is-invalid', showInvalid);
        input.classList.toggle('error-input', showInvalid);

        const status = document.getElementById('sim-code-status');
        if (status) {
            status.className = 'sim-code-field__status' + (showValid ? ' is-valid' : (showInvalid ? ' is-invalid' : ''));
        }

        return allPass;
    }

    // Strip disallowed characters, enforce the type-specific max length, then repaint.
    function handleInput() {
        const input = document.getElementById('sim-code');
        if (!input) return;

        // Strip whitespace / punctuation injected by mobile auto-punctuation (iOS/Gboard
        // "double-space inserts a period"). Deferred to the next frame: reassigning
        // .value mid-gesture desyncs some mobile keyboards' internal composition state
        // from the real DOM value and they then delete real characters on the next
        // keystroke. Letting the keyboard's edit land first, then cleaning up, avoids that.
        if (/[^A-Za-z0-9]/.test(input.value)) {
            const el = input;
            requestAnimationFrame(() => {
                const caret = el.selectionStart;
                const keptBeforeCaret = el.value.slice(0, caret).replace(/[^A-Za-z0-9]/g, '').length;
                el.value = el.value.replace(/[^A-Za-z0-9]/g, '');
                el.setSelectionRange(keptBeforeCaret, keptBeforeCaret);
                el.dispatchEvent(new Event('input', { bubbles: true }));
            });
            return; // The dispatched input event re-runs this on the cleaned value.
        }

        const value = input.value.trim();
        if (value.startsWith('372')) {
            const digitsOnly = value.replace(/[^0-9]/g, '');
            if (digitsOnly !== value) { input.value = digitsOnly; return; }
            if (value.length > 11) { input.value = value.substring(0, 11); return; }
        } else if (value.startsWith('8941') || value.startsWith('8961')) {
            if (value.length > 20) { input.value = value.substring(0, 20); return; }
        } else {
            if (value.length > 22) { input.value = value.substring(0, 22); return; }
            input.setAttribute('minlength', '8');
            input.setAttribute('maxlength', '22');
            input.setAttribute('pattern', '[A-Za-z0-9]{8,22}');
            input.setAttribute('title', 'SIM code must be 8-22 characters long and contain only letters and numbers');
        }

        // Typing clears any server-side error message / red state; refresh() re-applies
        // the red outline afterwards if the value still fails a rule (and touched).
        const errorMsg = document.getElementById('error-message');
        if (errorMsg) errorMsg.style.display = 'none';
        const notFound = document.getElementById('sim-card-not-found');
        if (notFound) notFound.style.display = 'none';
        input.classList.remove('is-invalid', 'is-valid', 'error-input');

        refresh(touched);
    }

    function bindInput(input) {
        input.addEventListener('input', handleInput);
        input.addEventListener('blur', function () {
            touched = true;
            refresh(true);
        });
        input.addEventListener('paste', function (e) {
            e.preventDefault();
            const pasted = (e.clipboardData || window.clipboardData).getData('text');
            // Keep letters/digits only, cap at the widest allowed length; the dispatched
            // 'input' event re-runs handleInput() to trim to the type-specific length.
            input.value = pasted.replace(/[^A-Za-z0-9]/g, '').substring(0, 22);
            input.dispatchEvent(new Event('input', { bubbles: true }));
        });
    }

    // Replace the module-level submit handler attached at load time by swapping the node.
    const simCodeForm = document.getElementById('sim-code-form');
    if (!simCodeForm) {
        bindInput(simCodeInput);
        refresh(false);
        return;
    }

    const newForm = simCodeForm.cloneNode(true);
    simCodeForm.parentNode.replaceChild(newForm, simCodeForm);

    const form = document.getElementById('sim-code-form');
    const input = document.getElementById('sim-code');
    bindInput(input);

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        const value = input.value.trim();

        if (value.length === 0) {
            touched = true;
            refresh(true);
            showSimCodeValidationError(M.empty_sim_error || 'Please enter your SIM card number.');
            input.focus();
            return false;
        }

        touched = true;
        const allPass = refresh(true);
        if (!allPass) {
            const rules = getRulesForCode(value).rules;
            const firstFail = rules.find((r) => !r.pass);
            let msg = M.sim_code_format_error_text || 'SIM code must be 8-22 characters long and contain only letters and numbers.';
            if (value.startsWith('372')) {
                msg = (firstFail && firstFail.key === 'charset')
                    ? (M.gps_sim_numeric_error || 'GPS SIM card numbers must contain only digits (0-9).')
                    : (M.gps_sim_length_error || 'Please enter all 11 characters of your GPS SIM card number.');
            } else if (value.startsWith('8941') || value.startsWith('8961')) {
                msg = (firstFail && firstFail.key === 'charset')
                    ? (M.sim_alphanumeric_error || 'Swiss and Australian SIM card numbers must contain only letters and digits (A-Z, a-z, 0-9).')
                    : (M.sim_length_error || 'Please enter all 20 characters of your SIM card number.');
            }
            showSimCodeValidationError(msg);
            input.focus();
            return false;
        }

        console.log('SIM code validation passed. Processing activation...');
        processSimActivation(value);
        return false;
    });

    // Paint the initial (neutral) state, honouring any value pre-filled via the QR /
    // deep-link path.
    refresh(false);
}

// Function to process SIM activation after validation
function processSimActivation(simCode) {
    console.log('Processing SIM activation for code:', simCode);
    
    // Show loading state if needed
    const nextButton = document.getElementById('sim-code-form').querySelector('button[type="submit"]');
    if (nextButton) {
        nextButton.disabled = true;
        nextButton.innerHTML = window.simActivationMessages.processing_text || 'Processing...';
    }
    
    // Persist SIM code to storage and ensure URL is clean of legacy params
    setStoredSimCode(simCode);
    const url = new URL(window.location.href);
    url.searchParams.delete('sim-code');
    url.searchParams.delete('qr');
    window.history.replaceState({}, '', url.toString());
    
    console.log('Updated URL parameters:', window.location.href);
    
    // Use the existing activation code path based on SIM type
    if (simCode.startsWith('372')) {
        // GPS SIM - ensure it contains only numbers and has 11 characters
        if (!/^\d+$/.test(simCode)) {
            showSimCodeValidationError(window.simActivationMessages.gps_sim_numeric_error || 'GPS SIM card numbers must contain only digits (0-9).');
            if (nextButton) {
                nextButton.disabled = false;
                nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
            }
            return;
        }
        console.log('GPS SIM detected');
        showGpsForm(simCode);
    } else if (simCode.startsWith('8941') || simCode.startsWith('8961')) {
        // Swiss or Australian SIM - ensure it contains only alphanumeric characters and has 20 characters
        if (!/^[A-Za-z0-9]+$/.test(simCode)) {
            showSimCodeValidationError(window.simActivationMessages.sim_alphanumeric_error || 'Swiss and Australian SIM card numbers must contain only letters and digits (A-Z, a-z, 0-9).');
            if (nextButton) {
                nextButton.disabled = false;
                nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
            }
            return;
        }
        console.log('Swiss/Australian SIM detected');
        showTravelSimForm(simCode);
    } else {
        // Other SIM types - add general alphanumeric and length validation
        console.log('Standard SIM detected');
        
        // General SIM validation: 8-22 characters, alphanumeric only
        if (simCode.length < 8 || simCode.length > 22) {
            showSimCodeValidationError(window.simActivationMessages.sim_code_format_error_text || 'SIM code must be 8-22 characters long and contain only letters and numbers.');
            if (nextButton) {
                nextButton.disabled = false;
                nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
            }
            return;
        }
        
        // Ensure general SIM contains only alphanumeric characters
        if (!/^[A-Za-z0-9]+$/.test(simCode)) {
            showSimCodeValidationError(window.simActivationMessages.sim_code_format_error_text || 'SIM code must be 8-22 characters long and contain only letters and numbers.');
            if (nextButton) {
                nextButton.disabled = false;
                nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
            }
            return;
        }
        
        checkSimStatus(simCode);
    }
}

// Function to check SIM status via API
async function checkSimStatus(simCode) {
    const activationLanguage = document.getElementById("activation-language")?.value || 'EN';
    const apiUrl = `${app_url}/public/beachsim-sim-cards/${simCode}?language=${activationLanguage}`;
    
    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            // Show error message
            const errorElem = document.getElementById("error-message");
            const notFoundMessage = (simCode && simCode.startsWith('8937'))
              ? 'SIM code not found. For GPS SIM cards activation, please use the phone number beginning with 372 without the "+" and try again.'
              : (window.simActivationMessages.sim_not_found_error || 'SIM code not found');
            errorElem.innerHTML = 
                '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#DC2626"/>' +
                '</svg>' +
                '<span style="margin-left: 8px;">' + notFoundMessage + '</span>';
            
            errorElem.className = "activation-status-text blocked";
            errorElem.style.display = "flex";
            errorElem.style.alignItems = "center";
            errorElem.style.padding = "12px 16px";
            errorElem.style.backgroundColor = "#FEE2E2";
            errorElem.style.border = "1px solid #DC2626";
            errorElem.style.borderRadius = "4px";
            errorElem.style.color = "#DC2626";
            errorElem.style.fontSize = "14px";
            errorElem.style.fontWeight = "500";
            
            // Re-enable the button
            const nextButton = document.getElementById('sim-code-form').querySelector('button[type="submit"]');
            if (nextButton) {
                nextButton.disabled = false;
                nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
            }
            
            return;
        }
        
        // Process the successful response
        const result = await response.json();

        // Early brand verification before proceeding UI
        const pageBrandId = getPageBrandId();
        const serverBrandId = Number((result && (result.brandId ?? result.supplier?.brandId ?? result.requestActivationData?.brandId ?? result.brand?.id)) ?? NaN);
        if (!Number.isNaN(serverBrandId) && serverBrandId !== pageBrandId) {
            showBrandMismatchError('error-message');
            return;
        }

        // Check supplier identity — certain suppliers require activation via an external website,
        // but only when the SIM code is alphanumeric (7–12 chars) and NOT purely numeric.
        const supplierIdentity = result.supplier?.identity;
        const ESIM_EXTERNAL_SUPPLIER_IDENTITIES = [70, 105, 106, 110, 111];
        // Must be 7-12 chars, contain at least one letter, and not be purely numeric
        const isEsimSimCode = simCode.length >= 7 &&
                              simCode.length <= 12 &&
                              /[A-Za-z]/.test(simCode) &&
                              !/^\d+$/.test(simCode);

        // Determine if this is an Amazon order:
        // true when sim.storage or sim.amazonASIN is non-null/non-empty and contains the word "amazon"
        const storage    = (result.sim?.storage    || '').toLowerCase().trim();
        const amazonASIN = (result.sim?.amazonASIN || '').toLowerCase().trim();

        const isAmazon = storage.includes('amazon')
            || amazonASIN.includes('amazon')
            || amazonASIN.length > 0;

        // Get auth status early to check priority conditions
        const authStatus = result.sim?.auth?.status;

        console.log('[eSIM check] simCode:', simCode, '| length:', simCode.length, '| supplierIdentity:', supplierIdentity, '| isEsimSimCode:', isEsimSimCode, '| isAmazon:', isAmazon, '| authStatus:', authStatus);
        
        // Check if the SIM has already been activated (verified auth status) - priority check
        if (authStatus === 'verified') {
            showVerifiedAuthActivationMessage(result, simCode);
            // Re-enable the button
            const nextButton = document.getElementById('sim-code-form').querySelector('button[type="submit"]');
            if (nextButton) {
                nextButton.disabled = false;
                nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
            }
            return;
        }

        // Check for external eSIM suppliers (only if auth is not verified)
        if (ESIM_EXTERNAL_SUPPLIER_IDENTITIES.includes(supplierIdentity) && isEsimSimCode) {
            // Build the external URL using option data from the response
            const optionId = result.option?.identity ?? '';
            const optionExternalId = result.option?.externalId ?? '';
            const externalUrl = `https://beachsim.com?supplierID=${supplierIdentity}&optionId=${optionId}&optionExternalId=${optionExternalId}`;
            showEsimExternalActivationInfo(simCode, externalUrl, result, isAmazon);
            // Re-enable the button
            const nextButton = document.getElementById('sim-code-form').querySelector('button[type="submit"]');
            if (nextButton) {
                nextButton.disabled = false;
                nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
            }
            return;
        }
        
        // Hide error message
        document.getElementById("error-message").style.display = "none";
        
        // Hide the initial activation form
        document.getElementById("activation-form").style.display = "none";
        
        // Update UI based on loading status
        handleSimStatusResult(result, simCode);
        
    } catch (error) {
        console.error("Error checking SIM status:", error);
        
        // Show error message
        const errorElem = document.getElementById("error-message");
        errorElem.innerHTML = 
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#DC2626"/>' +
            '</svg>' +
            '<span style="margin-left: 8px;">' + (window.simActivationMessages.server_error || 'Error checking SIM status. Please try again.') + '</span>';
        
        errorElem.className = "activation-status-text blocked";
        errorElem.style.display = "flex";
        
        // Re-enable the button
        const nextButton = document.getElementById('sim-code-form').querySelector('button[type="submit"]');
        if (nextButton) {
            nextButton.disabled = false;
            nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
        }
    }
}

// Show sign-up panel for eSIM cards that must be activated via an external website
function showEsimExternalActivationInfo(simCode, externalUrl, result, isAmazon) {
    // Hide the main activation form
    const activationForm = document.getElementById('activation-form');
    if (activationForm) activationForm.style.display = 'none';

    // Hide error message
    const errorElem = document.getElementById('error-message');
    if (errorElem) errorElem.style.display = 'none';

    const panel = document.getElementById('esim-external-activation');
    if (!panel) return;

    // Store everything the submit handler needs
    panel.dataset.externalUrl      = externalUrl;
    panel.dataset.simCode          = simCode;
    panel.dataset.optionExternalId = result.option?.externalId ?? '';
    panel.dataset.isAmazon         = isAmazon ? 'true' : 'false';
    // Store the full result globally so we can fall back to the standard activation flow on signup error
    window._lastSimResult = result;

    // Reset the panel to its initial state (in case user goes back and tries again)
    const formBody  = document.getElementById('esim-signup-form-body');
    const successEl = document.getElementById('esim-signup-success');
    const errorEl   = document.getElementById('esim-signup-error');
    const submitBtn = document.getElementById('esim-signup-submit');
    if (formBody)  formBody.style.display  = 'block';
    if (successEl) successEl.style.display = 'none';
    if (errorEl)   errorEl.style.display   = 'none';
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Sign up'; }

    panel.style.display = 'block';
}

// Handle the email sign-up form submission — POSTs to the 3rd-party auth API
async function submitEsimSignup(isResend) {
    const panel = document.getElementById('esim-external-activation');
    if (!panel) return;

    const firstName = document.getElementById('esim-signup-first-name')?.value.trim() || '';
    const lastName  = document.getElementById('esim-signup-last-name')?.value.trim()  || '';
    const email     = document.getElementById('esim-signup-email')?.value.trim()      || '';

    const errorEl   = document.getElementById('esim-signup-error');
    const successEl = document.getElementById('esim-signup-success');
    const formBody  = document.getElementById('esim-signup-form-body');
    const submitBtn = document.getElementById('esim-signup-submit');

    function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.style.display = 'flex';
    }
    function clearError() {
        if (errorEl) errorEl.style.display = 'none';
    }

    // On resend, skip validation and re-use stored values
    const resolvedEmail     = isResend ? (panel.dataset.lastEmail     || email) : email;
    const resolvedFirstName = isResend ? (panel.dataset.lastFirstName || firstName) : firstName;
    const resolvedLastName  = isResend ? (panel.dataset.lastLastName  || lastName)  : lastName;
    const externalId        = panel.dataset.optionExternalId || '';
    const isAmazon          = panel.dataset.isAmazon === 'true';

    if (!isResend) {
        clearError();

        if (!resolvedFirstName || !resolvedLastName || !resolvedEmail) {
            showError('Please fill in all fields before continuing.');
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(resolvedEmail)) {
            showError('Please enter a valid email address.');
            return;
        }
    }

    // Loading state
    if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
    }

    try {
        const response = await fetch(`${app_url}/3rd-party/auth/signup`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email:      resolvedEmail,
                firstName:  resolvedFirstName,
                lastName:   resolvedLastName,
                externalId: externalId,
                simCode:    panel.dataset.simCode || '',
                purchaseSource: 'LOOPBACK'
            })
        });

        const data = await response.json().catch(() => ({}));

        if (response.status !== 200 && response.status !== 201) {
            console.warn('eSIM signup failed, falling back to standard activation flow. Status:', response.status);
            fallbackToStandardActivation(panel, resolvedFirstName, resolvedLastName, resolvedEmail, submitBtn);
            return;
        }

        // Success — store values for potential resend
        panel.dataset.lastEmail     = resolvedEmail;
        panel.dataset.lastFirstName = resolvedFirstName;
        panel.dataset.lastLastName  = resolvedLastName;

        // Hide form, show success state
        if (formBody)  formBody.style.display  = 'none';
        clearError();

        const successEmailEl = document.getElementById('esim-signup-success-email');
        if (successEmailEl) successEmailEl.textContent = resolvedEmail;
        if (successEl) successEl.style.display = 'flex';

    } catch (err) {
        console.error('eSIM signup error:', err);
        fallbackToStandardActivation(panel, resolvedFirstName, resolvedLastName, resolvedEmail, submitBtn);
    }
}

/**
 * Fallback helper: when the /3rd-party/auth/signup request fails, hide the eSIM
 * sign-up panel and fall back to the standard activation UI (same path that
 * checkSimStatus() takes on a successful lookup). Any personal details the user
 * already entered are pre-filled into the standard form so they don't have to
 * repeat them.
 *
 * @param {HTMLElement} panel        - The #esim-external-activation panel element
 * @param {string}      firstName    - First name the user entered
 * @param {string}      lastName     - Last name the user entered
 * @param {string}      email        - Email address the user entered
 * @param {HTMLElement} [submitBtn]  - The submit button (re-enabled on error)
 */
function fallbackToStandardActivation(panel, firstName, lastName, email, submitBtn) {
    // Re-enable the submit button in case the user somehow re-opens the panel
    if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Sign up';
    }

    // Recover the stored API result and SIM code
    const simCode = panel.dataset.simCode || '';
    let result = window._lastSimResult || {};

    if (!result.loadingStatus) {
        console.warn('Fallback result is empty or missing loadingStatus. Form may not render correctly.');
    }

    // Hide the eSIM sign-up panel
    panel.style.display = 'none';

    // Mirror exactly what checkSimStatus() does on a successful response:
    // Hide error message
    document.getElementById('error-message').style.display = 'none';

    // Hide the initial activation form
    document.getElementById('activation-form').style.display = 'none';

    // Update UI based on loading status
    handleSimStatusResult(result, simCode);

    // Pre-fill personal info the user already entered so they don't repeat it
    // For NEW state
    const firstNameEl = document.getElementById('firstName');
    const lastNameEl  = document.getElementById('lastName');
    const emailEl     = document.getElementById('email');
    if (firstNameEl && firstName) { firstNameEl.value = firstName; firstNameEl.dispatchEvent(new Event('input', { bubbles: true })); }
    if (lastNameEl  && lastName)  { lastNameEl.value  = lastName;  lastNameEl.dispatchEvent(new Event('input', { bubbles: true })); }
    if (emailEl     && email)     { emailEl.value     = email;     emailEl.dispatchEvent(new Event('input', { bubbles: true })); }

    // For TOUCHED/BLOCKED state (change details form)
    const changeFirstNameEl = document.getElementById('change-details-firstName');
    const changeLastNameEl  = document.getElementById('change-details-lastName');
    const changeEmailEl     = document.getElementById('change-details-email');
    if (changeFirstNameEl && firstName) { changeFirstNameEl.value = firstName; changeFirstNameEl.dispatchEvent(new Event('input', { bubbles: true })); }
    if (changeLastNameEl  && lastName)  { changeLastNameEl.value  = lastName;  changeLastNameEl.dispatchEvent(new Event('input', { bubbles: true })); }
    if (changeEmailEl     && email)     { changeEmailEl.value     = email;     changeEmailEl.dispatchEvent(new Event('input', { bubbles: true })); }

    // This fallback must collect details again, so keep only the new activation
    // form visible even if the status renderer showed an existing activation
    // summary first.
    const newActivationForm = document.getElementById('new-activation-form');
    const activationDetailsContainer = document.getElementById('activation-details-container');
    const changeDetailsForm = document.getElementById('change-details-form');
    const successMessage = document.getElementById('success-message');
    const successActivationContainer = document.getElementById('success-activation-container');
    if (activationDetailsContainer) activationDetailsContainer.style.display = 'none';
    if (changeDetailsForm) changeDetailsForm.style.display = 'none';
    if (successMessage) successMessage.style.display = 'none';
    if (successActivationContainer) successActivationContainer.style.display = 'none';

    if (newActivationForm) {
        newActivationForm.style.display = 'block';
        const simCodeEl = document.getElementById('simCode');
        const displaySimCodeEl = document.getElementById('display-sim-code');
        if (simCodeEl) simCodeEl.value = simCode;
        if (displaySimCodeEl) displaySimCodeEl.textContent = simCode;

        const deviceRequirements = result.deviceRequirements || [];
        const imeiValid = deviceRequirements.some(req => req.name === 'IMEI_VALID');
        const eidValid = deviceRequirements.some(req => req.name === 'EID_VALID');
        updateImeiEidVisibility(imeiValid, eidValid, document.querySelectorAll('.new-imei-eid'));
    }
}

// Show message when SIM has already been activated (verified auth status)
function showVerifiedAuthActivationMessage(result, simCode) {
    // Hide the main activation form
    const activationForm = document.getElementById('activation-form');
    if (activationForm) activationForm.style.display = 'none';

    // Hide error message
    const errorElem = document.getElementById('error-message');
    if (errorElem) errorElem.style.display = 'none';

    // Create a container for the verified activation message if it doesn't exist
    let messageContainer = document.getElementById('verified-auth-message');
    if (!messageContainer) {
        messageContainer = document.createElement('div');
        messageContainer.id = 'verified-auth-message';
        messageContainer.className = 'verified-activation-container';
        messageContainer.style.cssText = `
            padding: 24px;
            background-color: #F0FDF4;
            border: 1px solid #86EFAC;
            border-radius: 8px;
            margin: 20px 0;
            text-align: center;
        `;
        
        // Insert after the activation form
        const activationForm = document.getElementById('activation-form');
        if (activationForm && activationForm.parentNode) {
            activationForm.parentNode.insertBefore(messageContainer, activationForm.nextSibling);
        }
    }

    // Build the message content
    const successIcon = `
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin: 0 auto 16px;">
            <circle cx="24" cy="24" r="24" fill="#DCFCE7"/>
            <path d="M20 28L16 24M20 28L24 32M20 28L32 16" stroke="#16A34A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;

    const authEmail = result.sim?.auth?.email || 'your account';
    const heading = window.simActivationMessages.activation_completed || 'SIM Already Activated';
    // Raw message from settings (may contain a plain URL). We'll convert plain URLs into clickable links
    const message = window.simActivationMessages.verified_activation_message || 'This SIM has already been activated. Please check the BeachSim app for more details.';

    // Convert plain http(s) URLs in the message into clickable anchors that open in a new tab
    function linkify(text) {
        if (!text) return text;
        const urlRegex = /(\bhttps?:\/\/[^\s<]+)/gi;
        return text.replace(urlRegex, function(url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
    }

    const messageHtml = linkify(message);

    messageContainer.innerHTML = `
        ${successIcon}
        <h2 style="color: #15803D; font-size: 20px; font-weight: 600; margin: 0 0 8px 0;">
            ${heading}
        </h2>
        <p style="color: #4B5563; font-size: 14px; margin: 0 0 12px 0;">
            ${messageHtml}
        </p>
        ${authEmail ? `<p style="color: #6B7280; font-size: 13px; margin: 0;">Account: ${authEmail}</p>` : ''}
        <button onclick="resetActivationForm()" style="
            margin-top: 16px;
            padding: 10px 20px;
            background-color: #16A34A;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            font-weight: 500;
        ">
            Check Another SIM
        </button>
    `;

    messageContainer.style.display = 'block';
}

// Handle SIM status result and update UI
function handleSimStatusResult(result, simCode) {
    const deviceRequirements = result.deviceRequirements || [];
    
    // Store device requirements globally for use in change details form
    window.currentDeviceRequirements = deviceRequirements;
    
    const imeiValid = deviceRequirements.some(req => req.name === "IMEI_VALID");
    const eidValid = deviceRequirements.some(req => req.name === "EID_VALID");
    const newImeiEidElements = document.querySelectorAll(".new-imei-eid");
    
    // Determine which view to show based on loadingStatus
    if (result.loadingStatus === "1_NEW") {
        // Show new activation form for entering details
        document.getElementById("new-activation-form").style.display = "block";
        document.getElementById("simCode").value = simCode;
        document.getElementById("display-sim-code").textContent = simCode;
        
        // Handle IMEI/EID requirements
        updateImeiEidVisibility(imeiValid, eidValid, newImeiEidElements);
    } 
    else if (["2_TOUCHED", "3_BLOCKED", "4_REGISTERED"].includes(result.loadingStatus)) {
        // For touched, blocked, or registered, populate the unified container
        populateActivationDetails(result, imeiValid, eidValid, newImeiEidElements);
        
        // Show the unified activation details container
        document.getElementById("activation-details-container").style.display = "block";
    } 
    else if (result.loadingStatus === "5_LOADED") {
        // Show success message
        showSuccessMessage(result, imeiValid, eidValid, newImeiEidElements);
    } 
    else {
        // Fallback for unknown status
        document.getElementById("error-message").textContent = window.simActivationMessages.unknown_status_error || "Unknown status or error.";
        document.getElementById("error-message").style.display = "block";
        document.getElementById("activation-form").style.display = "block";
    }
    
    // Re-enable the button
    const nextButton = document.getElementById('sim-code-form').querySelector('button[type="submit"]');
    if (nextButton) {
        nextButton.disabled = false;
        nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
    }
}

// Helper function to show GPS form
function showGpsForm(simCode) {
    // Hide the activation form
    document.getElementById("activation-form").style.display = "none";
    
    // Show GPS tracker form
    document.getElementById("gps-tracker-form").style.display = "block";
    
    // Ensure the stored SIM code is kept in sync
    setStoredSimCode(simCode);

    // Prefill the GPS phone number if applicable
    if (document.getElementById('gpsPhoneNumber')) {
        document.getElementById('gpsPhoneNumber').value = simCode;
        
        // Update the counter if it exists
        const counter = document.getElementById('gpsPhoneNumber-counter');
        if (counter) {
            counter.textContent = `${simCode.length} / 11`;
        }
    }
    
    // Re-enable the submit button
    const nextButton = document.getElementById('sim-code-form').querySelector('button[type="submit"]');
    if (nextButton) {
        nextButton.disabled = false;
        nextButton.innerHTML = window.simActivationMessages.next_button_text || 'Next';
    }
}

// Helper function to show Travel SIM form
function showTravelSimForm(simCode) {
    // Hide the activation form
    document.getElementById("activation-form").style.display = "none";
    
    // Show Travel SIM form
    document.getElementById("travel-sim-form").style.display = "block";
    
    // Ensure the stored SIM code is kept in sync
    setStoredSimCode(simCode);

    // Get date fields and residence header by ID
    const arrivalDateSection = document.getElementById('travelArrivalDate-section');
    const activationDateSection = document.getElementById('travelActivationDate-section');
    const australianResidenceHeader = document.getElementById('australian-residence-header');
    
    // Get the actual date input fields
    const arrivalDateInput = document.getElementById('travelArrivalDate');
    const activationDateInput = document.getElementById('travelActivationDate');
    
    // Hide date fields and residence header by default
    if (arrivalDateSection) arrivalDateSection.style.display = 'none';
    if (activationDateSection) activationDateSection.style.display = 'none';
    if (australianResidenceHeader) australianResidenceHeader.style.display = 'none';
    
    // Remove required attribute when fields are hidden
    if (arrivalDateInput) arrivalDateInput.removeAttribute('required');
    if (activationDateInput) activationDateInput.removeAttribute('required');
    
    // Show Swiss passport section for both 8941 and 8961
    if (simCode.startsWith('8941') || simCode.startsWith('8961')) {
        document.getElementById("swiss-passport-section").style.display = "block";
        
        // Update passport section text based on SIM type
        const registrationTitle = document.getElementById('passport-registration-title');
        const registrationHint = document.getElementById('passport-registration-hint');
        const documentTypeSelector = document.querySelector('.document-type-selector');
        
        if (simCode.startsWith('8961')) {
            // Show date fields and residence header for Australian SIM only
            if (arrivalDateSection) arrivalDateSection.style.display = 'block';
            if (activationDateSection) activationDateSection.style.display = 'block';
            if (australianResidenceHeader) australianResidenceHeader.style.display = 'block';
            
            // Add required attribute back for Australian SIMs
            if (arrivalDateInput) arrivalDateInput.setAttribute('required', '');
            if (activationDateInput) activationDateInput.setAttribute('required', '');
            
            // Initialize date fields for Australian SIMs
            initializeTravelDateFields();
            
            // Update text for Australian SIM
            if (registrationTitle) registrationTitle.textContent = window.simActivationMessages.australianPassportTitle;
            if (registrationHint) registrationHint.textContent = window.simActivationMessages.australianPassportHint;
            if (documentTypeSelector) documentTypeSelector.style.display = 'none';
            
            // For Australian SIM: Ensure ID card sections are reset and hidden, passport section is shown
            const idCardSection = document.getElementById('id-card-upload-section');
            const passportSection = document.getElementById('passport-upload-section');
            
            // Reset ID card upload fields
            const idFrontInput = document.getElementById('travelIdFront');
            const idBackInput = document.getElementById('travelIdBack');
            const idFrontName = document.getElementById('travelIdFrontName');
            const idBackName = document.getElementById('travelIdBackName');
            
            if (idFrontInput) idFrontInput.value = '';
            if (idBackInput) idBackInput.value = '';
            if (idFrontName) idFrontName.textContent = window.simActivationMessages.no_file_chosen_text || 'No file chosen';
            if (idBackName) idBackName.textContent = window.simActivationMessages.no_file_chosen_text || 'No file chosen';
            
            // Hide ID card section and show passport section
            if (idCardSection) idCardSection.style.display = 'none';
            if (passportSection) passportSection.style.display = 'block';
            
            // If there are selector buttons, make sure passport is active
            const passportSelector = document.getElementById('passport-selector');
            const idCardSelector = document.getElementById('id-card-selector');
            
            if (passportSelector) passportSelector.classList.add('active');
            if (idCardSelector) idCardSelector.classList.remove('active');
            
            // Initialize passport file upload for Australian SIM
            initializeFileUploads();
        } else {
            // Update text for Swiss SIM
            if (registrationTitle) registrationTitle.textContent = window.simActivationMessages.swissPassportTitle;
            if (registrationHint) registrationHint.textContent = window.simActivationMessages.swissPassportHint;
            if (documentTypeSelector) documentTypeSelector.style.display = 'block';
            
            // Initialize Swiss file uploads
            initializeSwissFileUploads();
        }
    }
    
    // Store the SIM code in the travel SIM form
    if (document.getElementById('travelSimNumber')) {
        document.getElementById('travelSimNumber').value = simCode;
    }
    
    // Initialize date of birth field
    initializeDateOfBirthField();
}

// Function to initialize all file uploads
function initializeFileUploads() {
    // Initialize passport file upload
    const passportInput = document.getElementById('swissPassport');
    const passportName = document.getElementById('swissPassportName');
    
    if (passportInput && passportName) {
        // Remove any existing event listeners
        passportInput.removeEventListener('change', handlePassportFileChange);
        
        // Add new event listener
        passportInput.addEventListener('change', handlePassportFileChange);
        
        // Check for existing files
        if (passportInput.files && passportInput.files.length > 0) {
            passportName.textContent = passportInput.files[0].name;
        } else {
            passportName.textContent = window.simActivationMessages.no_file_chosen_text || 'No file chosen';
        }
    }
}

// Document ready function
document.addEventListener('DOMContentLoaded', function() {
    // Initialize file upload handlers
    initializeFileUploads();
    
    // Initialize Swiss document selectors if they exist
    if (document.getElementById('passport-selector')) {
        initializeSwissDocumentSelector();
    }
    
    // Initialize date fields if they exist AND are visible (for Australian SIMs only)
    const travelSimNumber = document.getElementById('travelSimNumber');
    if (document.getElementById('travelArrivalDate') && 
        travelSimNumber && 
        travelSimNumber.value && 
        travelSimNumber.value.startsWith('8961')) {
        initializeTravelDateFields();
    }
});

// Initialize arrival and activation date fields
function initializeTravelDateFields() {
    // Get today's date for minimum dates
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    
    // Initialize arrival date field
    const arrivalDateInput = document.getElementById("travelArrivalDate");
    const arrivalDateSection = document.getElementById('travelArrivalDate-section');
    
    // Only initialize if input exists AND section is visible (for Australian SIMs)
    if (arrivalDateInput && (!arrivalDateSection || arrivalDateSection.style.display !== 'none')) {
        // Set min date to today to prevent past dates
        arrivalDateInput.setAttribute("min", formattedToday);
        
        // Add change listener to update activation date min when arrival date changes
        arrivalDateInput.addEventListener("change", function() {
            updateActivationDateMin();
        });
    }
    
    // Initialize activation date field
    const activationDateInput = document.getElementById("travelActivationDate");
    const activationDateSection = document.getElementById('travelActivationDate-section');
    
    // Only initialize if input exists AND section is visible (for Australian SIMs)
    if (activationDateInput && (!activationDateSection || activationDateSection.style.display !== 'none')) {
        // Set min date to today initially
        activationDateInput.setAttribute("min", formattedToday);
    }
    
    // Only update if both fields are visible (for Australian SIMs)
    if (arrivalDateInput && activationDateInput && 
        (!arrivalDateSection || arrivalDateSection.style.display !== 'none') &&
        (!activationDateSection || activationDateSection.style.display !== 'none')) {
        // Initial update of activation date min value
        updateActivationDateMin();
    }
}

// Update activation date min value based on arrival date
function updateActivationDateMin() {
    const arrivalDateInput = document.getElementById("travelArrivalDate");
    const activationDateInput = document.getElementById("travelActivationDate");
    const arrivalDateSection = document.getElementById('travelArrivalDate-section');
    const activationDateSection = document.getElementById('travelActivationDate-section');
    
    // Get current SIM type to ensure we only run for Australian SIMs
    const travelSimNumber = document.getElementById('travelSimNumber');
    const isAustralianSim = travelSimNumber && travelSimNumber.value && travelSimNumber.value.startsWith('8961');
    
    // Check if fields exist, are visible, and we're working with an Australian SIM
    const fieldsExistAndVisible = arrivalDateInput && activationDateInput && 
                                 (!arrivalDateSection || arrivalDateSection.style.display !== 'none') &&
                                 (!activationDateSection || activationDateSection.style.display !== 'none');
    
    if (fieldsExistAndVisible && isAustralianSim && arrivalDateInput.value) {
        // Set activation date min to arrival date
        activationDateInput.setAttribute("min", arrivalDateInput.value);
        
        // If current activation date is before arrival date, reset it
        if (activationDateInput.value && activationDateInput.value < arrivalDateInput.value) {
            activationDateInput.value = arrivalDateInput.value;
        }
    }
}

// Helper function to update IMEI/EID visibility
function updateImeiEidVisibility(imeiValid, eidValid, newImeiEidElements) {
    if (imeiValid) {
        document.getElementById("new-imei-container").style.display = "flex";
        document.getElementById("activation-imei-container").style.display = "flex";
        document.getElementById("new-imei-container").required = true;
        document.getElementById("activation-imei-container").required = true;
    } else {
        document.getElementById("new-imei-container").style.display = "none";
        document.getElementById("activation-imei-container").style.display = "none";
        document.getElementById("new-imei-container").required = false;
        document.getElementById("activation-imei-container").required = false;
    }
    
    if (eidValid) {
        document.getElementById("new-eid-container").style.display = "flex";
        document.getElementById("activation-eid-container").style.display = "flex";
        document.getElementById("new-eid-container").required = true;
        document.getElementById("activation-eid-container").required = true;
    } else {
        document.getElementById("new-eid-container").style.display = "none";
        document.getElementById("activation-eid-container").style.display = "none";
        document.getElementById("new-eid-container").required = false;
        document.getElementById("activation-eid-container").required = false;
    }
    
    if (!imeiValid && !eidValid) {
        newImeiEidElements.forEach(el => el.style.display = "none");
    } else {
        newImeiEidElements.forEach(el => el.style.display = "block");
    }
}

// Helper function to populate activation details
function populateActivationDetails(result, imeiValid, eidValid, newImeiEidElements) {
    window.requestActivationData = result.requestActivationData;
    const data = result.requestActivationData;
    const imei = data.imei || "";
    const eid = data.eid || "";
    
    // Store current activation details for use in change details form
    window.currentActivationDetails = {
        simCode: data.simCode || "",
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        email: data.email || "",
        activationDate: data.activationDate || "",
        activationEnd: data.activationEnd || "",
        imei: imei,
        eid: eid
    };
    
    document.getElementById("activation-sim-code").textContent = data.simCode || "";
    document.getElementById("activation-name").textContent = ((data.firstName || "") + " " + (data.lastName || "")).trim();
    document.getElementById("activation-email").textContent = data.email || "—";
    document.getElementById("activation-dates").textContent = formatDate(data.activationDate) + " until " + formatDate(data.activationEnd);
    
    updateImeiEidVisibility(imeiValid, eidValid, newImeiEidElements);
    
    if (imeiValid) {
        document.getElementById("activation-imei").textContent = imei;
    }
    if (eidValid) {
        document.getElementById("activation-eid").textContent = eid;
    }
    
    // Update activation status based on loadingStatus
    updateActivationStatus(result.loadingStatus);
    
    // Ensure "Change details" button is visible
    const changeDetailsLinks = document.querySelectorAll('a[onclick="showChangeDetailsForm()"]');
    changeDetailsLinks.forEach(link => {
        // Only hide for Swiss/Australian/GPS SIMs
        if (data.simCode && (data.simCode.startsWith('8941') || data.simCode.startsWith('8961') || data.simCode.startsWith('372'))) {
            link.style.display = 'none';
            link.style.visibility = 'hidden';
            link.style.opacity = '0';
            link.style.pointerEvents = 'none';
        } else {
            link.style.display = 'inline-block';
            link.style.visibility = 'visible';
            link.style.opacity = '1';
            link.style.pointerEvents = 'auto';
        }
    });
}

// Helper function to update activation status
function updateActivationStatus(loadingStatus) {
    const statusIcon = document.getElementById("activation-status-icon");
    const statusText = document.getElementById("activation-status-text");
    
    if (loadingStatus === "2_TOUCHED") {
        statusIcon.innerHTML = 
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="#f59e0b" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M10 2a8 8 0 1 0 8 8h-2a6 6 0 1 1-6-6V2z"/>' +
          '</svg>';
        statusText.textContent = window.simActivationMessages.activation_pending || "Activation pending";
        statusText.className = "activation-status-text in-progress";
    } else if (loadingStatus === "3_BLOCKED") {
        statusIcon.innerHTML = 
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="red" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M10 2a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm3.54 10.54a1 1 0 0 1-1.42 1.42L10 11.42l-2.12 2.12a1 1 0 0 1-1.42-1.42L8.58 10 6.46 7.88a1 1 0 1 1 1.42-1.42L10 8.58l2.12-2.12a1 1 0 1 1 1.42 1.42L11.42 10l2.12 2.12z"/>' +
          '</svg>';
        statusText.textContent = window.simActivationMessages.sim_blocked || "SIM card is blocked";
        statusText.className = "activation-status-text blocked";
    } else if (loadingStatus === "4_REGISTERED") {
        statusIcon.innerHTML = 
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="green" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-11l4 4-4 4-1.414-1.414L11.172 10 7.586 6.414 9 5z"/>' +
          '</svg>';
        statusText.textContent = window.simActivationMessages.activation_completed || "Activation completed";
        statusText.className = "activation-status-text success";
    }
}

// Helper function to show success message
function showSuccessMessage(result, imeiValid, eidValid, newImeiEidElements) {
    document.getElementById("success-message").style.display = "block";
    const data = result.requestActivationData;
    
    document.getElementById("success-sim-code").textContent = data.simCode || "";
    document.getElementById("success-name").textContent = ((data.firstName || "") + " " + (data.lastName || "")).trim();
    document.getElementById("success-email").textContent = data.email || "—";
    document.getElementById("success-dates").textContent = formatDate(data.activationDate) + " until " + formatDate(data.activationEnd);
    
    updateImeiEidVisibility(imeiValid, eidValid, newImeiEidElements);
    
    // Ensure "Change details" button is visible based on SIM type
    const changeDetailsLinks = document.querySelectorAll('a[onclick="showChangeDetailsForm()"]');
    changeDetailsLinks.forEach(link => {
        // Only hide for Swiss/Australian/GPS SIMs
        if (data.simCode && (data.simCode.startsWith('8941') || data.simCode.startsWith('8961') || data.simCode.startsWith('372'))) {
            link.style.display = 'none';
            link.style.visibility = 'hidden';
            link.style.opacity = '0';
            link.style.pointerEvents = 'none';
        } else {
            link.style.display = 'inline-block';
            link.style.visibility = 'visible';
            link.style.opacity = '1';
            link.style.pointerEvents = 'auto';
        }
    });
}

function showSimCodeValidationError(message) {
    const errorElem = document.getElementById("error-message");
    const simCodeInput = document.getElementById('sim-code');
    
    if (errorElem && simCodeInput) {
        // Add error styling to input
        simCodeInput.classList.add('error-input');
        
        // Display error message with icon
        errorElem.innerHTML = 
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#DC2626"/>' +
          '</svg>' +
          '<span style="margin-left: 8px;">' + message + '</span>';
        
        // Style the error message
        errorElem.className = "activation-status-text blocked";
        errorElem.style.display = "flex";
        errorElem.style.alignItems = "center";
        errorElem.style.padding = "12px 16px";
        errorElem.style.backgroundColor = "#FEE2E2";
        errorElem.style.border = "1px solid #DC2626";
        errorElem.style.borderRadius = "4px";
        errorElem.style.color = "#DC2626";
        errorElem.style.fontSize = "14px";
        errorElem.style.fontWeight = "500";
        errorElem.style.marginTop = "10px";
        errorElem.style.marginBottom = "10px";
    }
}

// Add this function after the last function in the file
function initializeDateOfBirthField() {
    const dobInput = document.getElementById('dateOfBirth');
    if (dobInput) {
      flatpickr(dobInput, {
        dateFormat: "Y-m-d",
        maxDate: "today",
        defaultDate: null,
        allowInput: true
      });
    }
}

// Function to clear error messages when user starts typing
function setupChangeDetailsErrorClearing() {
  // Clear error messages when user starts typing
  const fields = [
    { input: "change-details-firstName", error: "change-details-firstName-error" },
    { input: "change-details-lastName", error: "change-details-lastName-error" },
    { input: "change-details-email", error: "change-details-email-error" },
    { input: "change-details-dateRange", error: "change-details-dateRange-error" },
    { input: "change-details-imei", error: "change-details-imei-invalid-error" },
    { input: "change-details-eid", error: "change-details-eid-invalid-error" }
  ];

  fields.forEach(field => {
    const inputElement = document.getElementById(field.input);
    const errorElement = document.getElementById(field.error);
    
    if (inputElement && errorElement) {
      inputElement.addEventListener('input', function() {
        errorElement.style.display = 'none';
      });
    }
  });
}
